// //backup\frontend\src\components\MembershipForm\StepByStepForm.jsx
// import React, { useState } from 'react';
// import { 
//   Box, 
//   Typography, 
//   Button, 
//   Stepper, 
//   Step, 
//   StepLabel, 
//   Card, 
//   CardContent, 
//   Dialog, 
//   DialogTitle, 
//   DialogContent, 
//   DialogActions,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { toast } from 'react-toastify';
// import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, Image, pdf, Font } from '@react-pdf/renderer';
// import './MembershipForm.css';
// import Logo from '../../assets/logo.jpeg';
// import becomeMemberServices from '../../services/becomeMemberServices';
// import EthiopicFont from '../../../src/static/NotoSansEthiopic-Bold.ttf';

// // Register Noto Sans Ethiopic font for Amharic text support
// Font.register({
//   family: 'NotoSansEthiopic',
//   src: EthiopicFont,
// });

// // Format US phone as XXX-YYY-ZZZZ (10 digits max)
// const formatPhoneUS = (value) => {
//   const digits = (value || '').replace(/\D/g, '').slice(0, 10);
//   if (digits.length <= 3) return digits;
//   if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
//   return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
// };

// const PHONE_FIELDS = ['phone', 'beneficiary_phone', 'beneficiary2_phone', 'spouse_phone'];

// const StepByStepMembershipForm = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
//   // PDF Styles
//   const pdfStyles = StyleSheet.create({
//     page: {
//       flexDirection: 'column',
//       backgroundColor: '#FFFFFF',
//       padding: 20,
//       fontSize: 9,
//       fontFamily: 'Helvetica',
//     },
//     header: {
//       flexDirection: 'row',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: 15,
//       borderBottom: '2px solid #000000',
//       paddingBottom: 10,
//     },
//     logo: {
//       width: 50,
//       height: 50,
//     },
//     headerCenter: {
//       flex: 1,
//       textAlign: 'center',
//       paddingHorizontal: 10,
//     },
//     amharicTitle: {
//       fontSize: 10,
//       fontWeight: 'bold',
//       marginBottom: 3,
//       fontFamily: 'NotoSansEthiopic',
//       textAlign: 'center',
//     },
//     englishTitle: {
//       fontSize: 11,
//       fontWeight: 'bold',
//       lineHeight: 1.2,
//       textAlign: 'center',
//     },
//     section: {
//       marginBottom: 6,
//     },
//     sectionTitle: {
//       fontSize: 10,
//       fontWeight: 'bold',
//       textAlign: 'center',
//       marginBottom: 6,
//       textTransform: 'uppercase',
//       borderBottom: '1px solid #000000',
//       paddingBottom: 2,
//     },
//     row: {
//       flexDirection: 'row',
//       marginBottom: 4,
//     },
//     fieldThird: {
//       flex: 0.33,
//       marginRight: 8,
//     },
//     fieldHalf: {
//       flex: 0.5,
//       marginRight: 8,
//     },
//     fieldTwoThirds: {
//       flex: 0.66,
//       marginRight: 8,
//     },
//     fieldLabel: {
//       fontSize: 8,
//       fontWeight: 'bold',
//       marginBottom: 1,
//     },
//     fieldValue: {
//       borderBottom: '1px solid #000000',
//       paddingBottom: 2,
//       paddingTop: 2,
//       minHeight: 12,
//       fontSize: 8,
//       paddingLeft: 2,
//       paddingRight: 2,
//     },
//     childBox: {
//       border: '1px solid #CCCCCC',
//       marginBottom: 3,
//       padding: 4,
//       pageBreakInside: 'avoid',
//     },
//     childTitle: {
//       fontSize: 8,
//       fontWeight: 'bold',
//       textAlign: 'center',
//       marginBottom: 2,
//       textDecoration: 'underline',
//     },
//     signatureSection: {
//       flexDirection: 'row',
//       marginTop: 5,
//       justifyContent: 'space-between',
//       marginBottom: 10,
//     },
//     signatureLeft: {
//       flex: 0.6,
//       marginRight: 15,
//     },
//     signatureRight: {
//       flex: 0.3,
//     },
//     signatureText: {
//       fontSize: 6,
//       marginBottom: 4,
//       lineHeight: 1.0,
//     },
//     signatureLabel: {
//       fontSize: 6,
//       fontWeight: 'bold',
//       marginBottom: 1,
//     },
//     signatureLine: {
//       borderBottom: '1px solid #000000',
//       height: 10,
//       width: '100%',
//     },
//   });

//   // Helper functions for PDF
//   const formatDate = (dateStr) => {
//     if (!dateStr) return '___________________';
//     try {
//       return new Date(dateStr).toLocaleDateString('en-US');
//     } catch {
//       return '___________________';
//     }
//   };

//   const createBlank = (value, length = 25) => {
//     if (value && value.trim()) {
//       return value.trim();
//     }
//     // Return empty string - the border-bottom in fieldValue style will create the line
//     return ' ';
//   };

//   // PDF Document Component
//   const MembershipPDF = ({ formData }) => (
//     <Document>
//       {/* Page 1 */}
//       <Page size="A4" style={pdfStyles.page}>
//         {/* Header */}
//         <View style={pdfStyles.header}>
//           <Image style={pdfStyles.logo} src={Logo} />
//           <View style={pdfStyles.headerCenter}>
//             <Text style={pdfStyles.amharicTitle}>ሃምሳ ሎሚ የኢትዮያውያን ማህበር - ናሽቪል - ቴነሲ</Text>
//             <Text style={pdfStyles.englishTitle}>HAMSA LOMI ETHIOPIAN ASSOCIATION{'\n'}NASHVILLE, TENNESSEE{'\n'}MEMBERSHIP APPLICATION</Text>
//           </View>
//           <Image style={pdfStyles.logo} src={Logo} />
//         </View>

//         {/* Applicant Information */}
//         <View style={pdfStyles.section}>
//           <Text style={pdfStyles.sectionTitle}>APPLICANT INFORMATION</Text>
          
//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>First Name:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.first_name, 20)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Middle Name:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.middle_name, 20)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Last Name:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.last_name, 20)}</Text>
//             </View>
//           </View>

//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Date of Birth:</Text>
//               <Text style={pdfStyles.fieldValue}>{formatDate(formData.dob)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>E-Mail:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.email, 25)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Phone:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.phone, 20)}</Text>
//             </View>
//           </View>

//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldTwoThirds}>
//               <Text style={pdfStyles.fieldLabel}>Current Address:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.address, 50)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Apt. #:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.apt, 10)}</Text>
//             </View>
//           </View>

//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>City:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.city, 20)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>State:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.state, 15)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Zip:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.zip, 15)}</Text>
//             </View>
//           </View>

//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldHalf}>
//               <Text style={pdfStyles.fieldLabel}>Marital Status:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.marital_status, 20)}</Text>
//             </View>
//           </View>
//         </View>

//         {/* Beneficiary Information */}
//         <View style={pdfStyles.section}>
//           <Text style={pdfStyles.sectionTitle}>BENEFICIARY INFORMATION</Text>
          
//           {/* Beneficiary 1 */}
//           <View style={pdfStyles.childBox}>
//             <Text style={pdfStyles.childTitle}>Beneficiary 1</Text>

//             <View style={pdfStyles.row}>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>First Name:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_first_name, 20)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>Middle Name:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_middle_name, 20)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>Last Name:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_last_name, 20)}</Text>
//               </View>
//             </View>

//             <View style={pdfStyles.row}>
//               <View style={pdfStyles.fieldHalf}>
//                 <Text style={pdfStyles.fieldLabel}>Phone:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_phone, 25)}</Text>
//               </View>
//             </View>

//             <View style={pdfStyles.row}>
//               <View style={pdfStyles.fieldTwoThirds}>
//                 <Text style={pdfStyles.fieldLabel}>Address:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_address, 50)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>Apt. #:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_apt, 10)}</Text>
//               </View>
//             </View>

//             <View style={pdfStyles.row}>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>City:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_city, 20)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>State:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_state, 15)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>Zip:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_zip, 15)}</Text>
//               </View>
//             </View>
//           </View>

//           {/* Beneficiary 2 */}
//           <View style={pdfStyles.childBox}>
//             <Text style={pdfStyles.childTitle}>Beneficiary 2</Text>

//             <View style={pdfStyles.row}>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>First Name:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_first_name, 20)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>Middle Name:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_middle_name, 20)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>Last Name:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_last_name, 20)}</Text>
//               </View>
//             </View>

//             <View style={pdfStyles.row}>
//               <View style={pdfStyles.fieldHalf}>
//                 <Text style={pdfStyles.fieldLabel}>Phone:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_phone, 25)}</Text>
//               </View>
//             </View>

//             <View style={pdfStyles.row}>
//               <View style={pdfStyles.fieldTwoThirds}>
//                 <Text style={pdfStyles.fieldLabel}>Address:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_address, 50)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>Apt. #:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_apt, 10)}</Text>
//               </View>
//             </View>

//             <View style={pdfStyles.row}>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>City:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_city, 20)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>State:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_state, 15)}</Text>
//               </View>
//               <View style={pdfStyles.fieldThird}>
//                 <Text style={pdfStyles.fieldLabel}>Zip:</Text>
//                 <Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_zip, 15)}</Text>
//               </View>
//             </View>
//           </View>
//         </View>

//         {/* Spouse Information */}
//         <View style={pdfStyles.section}>
//           <Text style={pdfStyles.sectionTitle}>SPOUSE INFORMATION</Text>
          
//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>First Name:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_first_name, 20)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Middle Name:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_middle_name, 20)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Last Name:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_last_name, 20)}</Text>
//             </View>
//           </View>

//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Date of Birth:</Text>
//               <Text style={pdfStyles.fieldValue}>{formatDate(formData.spouse_dob)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>E-Mail:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_email, 25)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Phone:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_phone, 20)}</Text>
//             </View>
//           </View>
//         </View>

//         {/* Children Information */}
//         <View style={pdfStyles.section}>
//           <Text style={pdfStyles.sectionTitle}>CHILDREN INFORMATION</Text>
//           {Array.from({length: 7}, (_, index) => {
//             const child = (formData.children && formData.children[index]) || {};
//             return (
//               <View key={index} style={pdfStyles.childBox}>
//                 <Text style={pdfStyles.childTitle}>Child {index + 1}</Text>
                
//                 <View style={pdfStyles.row}>
//                   <View style={pdfStyles.fieldThird}>
//                     <Text style={pdfStyles.fieldLabel}>First Name:</Text>
//                     <Text style={pdfStyles.fieldValue}>{createBlank(child.first_name, 20)}</Text>
//                   </View>
//                   <View style={pdfStyles.fieldThird}>
//                     <Text style={pdfStyles.fieldLabel}>Middle Name:</Text>
//                     <Text style={pdfStyles.fieldValue}>{createBlank(child.middle_name, 20)}</Text>
//                   </View>
//                   <View style={pdfStyles.fieldThird}>
//                     <Text style={pdfStyles.fieldLabel}>Last Name:</Text>
//                     <Text style={pdfStyles.fieldValue}>{createBlank(child.last_name, 20)}</Text>
//                   </View>
//                 </View>

//                 <View style={pdfStyles.row}>
//                   <View style={pdfStyles.fieldHalf}>
//                     <Text style={pdfStyles.fieldLabel}>Relationship:</Text>
//                     <Text style={pdfStyles.fieldValue}>{createBlank(child.relationship, 20)}</Text>
//                   </View>
//                 </View>

//                 <View style={pdfStyles.row}>
//                   <View style={pdfStyles.fieldThird}>
//                     <Text style={pdfStyles.fieldLabel}>Gender:</Text>
//                     <Text style={pdfStyles.fieldValue}>{createBlank(child.gender, 15)}</Text>
//                   </View>
//                   <View style={pdfStyles.fieldThird}>
//                     <Text style={pdfStyles.fieldLabel}>Date of Birth:</Text>
//                     <Text style={pdfStyles.fieldValue}>{formatDate(child.dob)}</Text>
//                   </View>
//                   <View style={pdfStyles.fieldThird}>
//                     <Text style={pdfStyles.fieldLabel}>Disabled:</Text>
//                     <Text style={pdfStyles.fieldValue}>{createBlank(child.disabled, 15)}</Text>
//                   </View>
//                 </View>
//               </View>
//             );
//           })}
//         </View>

//         {/* Signature Section */}
//         <View style={pdfStyles.signatureSection}>
//           <View style={pdfStyles.signatureLeft}>
//             <Text style={pdfStyles.signatureText}>
//               By signing below, I acknowledge that I have read and understand the terms and conditions of membership. I certify that all information provided is true and accurate to the best of my knowledge.
//             </Text>
//             <Text style={pdfStyles.signatureLabel}>Signature:</Text>
//             <View style={pdfStyles.signatureLine}></View>
//           </View>
//           <View style={pdfStyles.signatureRight}>
//             <Text style={pdfStyles.signatureLabel}>Date:</Text>
//             <View style={pdfStyles.signatureLine}>
//               <Text style={{textAlign: 'center', paddingTop: 3, fontSize: 8}}>
//                 {new Date().toLocaleDateString('en-US')}
//               </Text>
//             </View>
//           </View>
//         </View>

//         {/* Office Use Only Section */}
//         <View style={pdfStyles.section}>
//           <Text style={pdfStyles.sectionTitle}>OFFICE USE ONLY</Text>
          
//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Membership Number:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank('', 20)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Date Received:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank('', 20)}</Text>
//             </View>
//             <View style={pdfStyles.fieldThird}>
//               <Text style={pdfStyles.fieldLabel}>Date Approved:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank('', 20)}</Text>
//             </View>
//           </View>

//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldHalf}>
//               <Text style={pdfStyles.fieldLabel}>Approved By:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank('', 30)}</Text>
//             </View>
//             <View style={pdfStyles.fieldHalf}>
//               <Text style={pdfStyles.fieldLabel}>Membership Fee Paid:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank('', 20)}</Text>
//             </View>
//           </View>

//           <View style={pdfStyles.row}>
//             <View style={pdfStyles.fieldHalf}>
//               <Text style={pdfStyles.fieldLabel}>Comments:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank('', 50)}</Text>
//             </View>
//             <View style={pdfStyles.fieldHalf}>
//               <Text style={pdfStyles.fieldLabel}>Status:</Text>
//               <Text style={pdfStyles.fieldValue}>{createBlank('', 20)}</Text>
//             </View>
//           </View>
//         </View>
//       </Page>
//     </Document>
//   );
  
//   // Step management
//   const [currentStep, setCurrentStep] = useState(0);
//   const [completedSteps, setCompletedSteps] = useState(new Set());
  
//   // Section visibility and prompts
//   const [showBeneficiaryPrompt, setShowBeneficiaryPrompt] = useState(false);
//   const [showSpousePrompt, setShowSpousePrompt] = useState(false);
//   const [showChildrenPrompt, setShowChildrenPrompt] = useState(false);
//   const [showBeneficiarySection, setShowBeneficiarySection] = useState(false);
//   const [showSpouseSection, setShowSpouseSection] = useState(false);
//   const [showChildrenSection, setShowChildrenSection] = useState(false);
//   const [showSecondBeneficiary, setShowSecondBeneficiary] = useState(false);
//   const [showBeneficiaryCountError, setShowBeneficiaryCountError] = useState(false);
  
//   // Form state
//   const [childCount, setChildCount] = useState(1);
//   const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
//   const [maritalStatus, setMaritalStatus] = useState('');
  
//   const [formData, setFormData] = useState({
//     // Applicant Information
//     first_name: '',
//     middle_name: '',
//     last_name: '',
//     dob: '',
//     email: '',
//     phone: '',
//     address: '',
//     apt: '',
//     city: '',
//     state: '',
//     zip: '',
//     marital_status: '',
    
//     // Beneficiary Information (Beneficiary 1)
//     beneficiary_first_name: '',
//     beneficiary_middle_name: '',
//     beneficiary_last_name: '',
//     beneficiary_phone: '',
//     beneficiary_address: '',
//     beneficiary_apt: '',
//     beneficiary_city: '',
//     beneficiary_state: '',
//     beneficiary_zip: '',

//     // Beneficiary 2 Information
//     beneficiary2_first_name: '',
//     beneficiary2_middle_name: '',
//     beneficiary2_last_name: '',
//     beneficiary2_phone: '',
//     beneficiary2_address: '',
//     beneficiary2_apt: '',
//     beneficiary2_city: '',
//     beneficiary2_state: '',
//     beneficiary2_zip: '',
    
//     // Spouse Information
//     spouse_first_name: '',
//     spouse_middle_name: '',
//     spouse_last_name: '',
//     spouse_dob: '',
//     spouse_email: '',
//     spouse_phone: '',
    
//     // Children - Initialize with 1 empty child
//     children: [{ first_name: '', middle_name: '', last_name: '', relationship: '', gender: '', disabled: '', dob: '' }]
//   });

//   const [errors, setErrors] = useState({});
  
//   // Step definitions
//   const steps = [
//     'Applicant Information',
//     'Beneficiary Information', 
//     'Spouse Information',
//     'Children Information',
//     'Review & Submit'
//   ];

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     const isPhoneField = PHONE_FIELDS.includes(name);
//     const nextValue = isPhoneField ? formatPhoneUS(value) : value;
//     setFormData(prev => ({
//       ...prev,
//       [name]: nextValue
//     }));
    
//     // Handle marital status change
//     if (name === 'marital_status') {
//       setMaritalStatus(nextValue);
//     }
    
//     // Clear error when user starts typing
//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ''
//       }));
//     }
//   };

//   const handleChildChange = (index, field, value) => {
//     const updatedChildren = [...formData.children];
//     updatedChildren[index] = {
//       ...updatedChildren[index],
//       [field]: value
//     };
//     setFormData(prev => ({
//       ...prev,
//       children: updatedChildren
//     }));
//   };

//   const addChild = () => {
//     if (childCount < 7) {
//       setFormData(prev => ({
//         ...prev,
//         children: [...prev.children, { first_name: '', middle_name: '', last_name: '', relationship: '', gender: '', disabled: '', dob: '' }]
//       }));
//       setChildCount(prev => prev + 1);
//     }
//   };

//   const removeChild = (index) => {
//     if (childCount > 1) {
//       const updatedChildren = formData.children.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         children: updatedChildren
//       }));
//       setChildCount(prev => prev - 1);
//     }
//   };

//   const handleDownloadPDF = async () => {
//     if (isGeneratingPDF) return;
    
//     setIsGeneratingPDF(true);
    
//     try {
//       const blob = await pdf(<MembershipPDF formData={formData} />).toBlob();
      
//       // Create download link
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = `Membership_Application_${new Date().toISOString().split('T')[0]}.pdf`;
      
//       // Trigger download
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
      
//       // Clean up
//       URL.revokeObjectURL(url);
      
//         setIsGeneratingPDF(false);
//         toast.success('PDF downloaded successfully!');
//     } catch (error) {
//         console.error('PDF generation error:', error);
//         setIsGeneratingPDF(false);
//       toast.error('Failed to generate PDF. Please try again.');
//     }
//   };

//   // Step validation functions
//   const validateApplicantSection = () => {
//     const newErrors = {};
//     const requiredFields = ['first_name', 'last_name', 'dob', 'email', 'phone', 'address', 'city', 'state', 'zip', 'marital_status'];
    
//     requiredFields.forEach(field => {
//       if (!formData[field]?.trim()) {
//         newErrors[field] = 'This field is required';
//       }
//     });

//     // Email validation
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (formData.email && !emailRegex.test(formData.email)) {
//       newErrors.email = 'Please enter a valid email address';
//     }

//     // US phone: exactly 10 digits (XXX-YYY-ZZZZ)
//     const phoneDigits = (formData.phone || '').replace(/\D/g, '');
//     if (formData.phone && phoneDigits.length !== 10) {
//       newErrors.phone = 'Please enter a valid 10-digit US phone number (XXX-YYY-ZZZZ)';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const validateBeneficiarySection = () => {
//     const newErrors = {};
//     const requiredFields = [
//       'beneficiary_first_name',
//       'beneficiary_last_name',
//       'beneficiary_address',
//       'beneficiary_city',
//       'beneficiary_state',
//       'beneficiary_zip',
//       'beneficiary2_first_name',
//       'beneficiary2_last_name',
//       'beneficiary2_address',
//       'beneficiary2_city',
//       'beneficiary2_state',
//       'beneficiary2_zip',
//     ];
    
//     requiredFields.forEach(field => {
//       if (!formData[field]?.trim()) {
//         newErrors[field] = 'This field is required';
//       }
//     });

//     // Optional phone fields: if provided, must be 10 digits (XXX-YYY-ZZZZ)
//     const beneficiaryPhoneDigits = (formData.beneficiary_phone || '').replace(/\D/g, '');
//     if (formData.beneficiary_phone && beneficiaryPhoneDigits.length !== 10) {
//       newErrors.beneficiary_phone = 'Please enter a valid 10-digit US phone number (XXX-YYY-ZZZZ)';
//     }
//     const beneficiary2PhoneDigits = (formData.beneficiary2_phone || '').replace(/\D/g, '');
//     if (formData.beneficiary2_phone && beneficiary2PhoneDigits.length !== 10) {
//       newErrors.beneficiary2_phone = 'Please enter a valid 10-digit US phone number (XXX-YYY-ZZZZ)';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const validateSpouseSection = () => {
//     if (!showSpouseSection) return true;
    
//     const newErrors = {};
//     const requiredFields = ['spouse_first_name', 'spouse_last_name', 'spouse_dob'];
    
//     requiredFields.forEach(field => {
//       if (!formData[field]?.trim()) {
//         newErrors[field] = 'This field is required';
//       }
//     });

//     // Email validation for spouse
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (formData.spouse_email && !emailRegex.test(formData.spouse_email)) {
//       newErrors.spouse_email = 'Please enter a valid email address';
//     }

//     // Optional spouse phone: if provided, must be 10 digits (XXX-YYY-ZZZZ)
//     const spousePhoneDigits = (formData.spouse_phone || '').replace(/\D/g, '');
//     if (formData.spouse_phone && spousePhoneDigits.length !== 10) {
//       newErrors.spouse_phone = 'Please enter a valid 10-digit US phone number (XXX-YYY-ZZZZ)';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const validateChildrenSection = () => {
//     if (!showChildrenSection) return true;
    
//     const newErrors = {};
//     formData.children.forEach((child, index) => {
//       if (child.first_name || child.middle_name || child.last_name || child.relationship || child.gender || child.disabled || child.dob) {
//         if (!child.first_name) newErrors[`child${index}_first_name`] = `Please enter a first name for child ${index + 1}`;
//         if (!child.last_name) newErrors[`child${index}_last_name`] = `Please enter a last name for child ${index + 1}`;
//         if (!child.relationship) newErrors[`child${index}_relationship`] = `Please select a relationship for child ${index + 1}`;
//         if (!child.gender) newErrors[`child${index}_gender`] = `Please select a gender for child ${index + 1}`;
//         if (!child.disabled) newErrors[`child${index}_disabled`] = `Please select disabled status for child ${index + 1}`;
//         if (!child.dob) newErrors[`child${index}_dob`] = `Please enter a birthdate for child ${index + 1}`;
//       }
//     });

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Step navigation functions
//   const handleApplicantSubmit = () => {
//     if (validateApplicantSection()) {
//       setCompletedSteps(prev => new Set([...prev, 0]));
//       setShowBeneficiaryPrompt(true);
//     } else {
//       toast.error('Please fill in all required fields correctly');
//     }
//   };

//   const handleBeneficiaryPromptResponse = (addBeneficiary) => {
//     if (addBeneficiary) {
//       setShowBeneficiaryPrompt(false);
//       setShowBeneficiarySection(true);
//       setCurrentStep(1);
//     } else {
//       toast.error('A beneficiary is required to proceed.');
//     }
//   };

//   const handleBeneficiarySubmit = () => {
//     // Require user to add a second beneficiary before continuing
//     if (!showSecondBeneficiary) {
//       setShowBeneficiaryCountError(true);
//       return;
//     }

//     if (validateBeneficiarySection()) {
//       setCompletedSteps(prev => new Set([...prev, 1]));
//       setShowBeneficiarySection(false);
      
//       // Check if applicant is single to skip spouse section
//       if (formData.marital_status === 'Single') {
//         setShowChildrenPrompt(true);
//       } else {
//         setShowSpousePrompt(true);
//       }
//     } else {
//       toast.error('Please fill in all required beneficiary fields');
//     }
//   };

//   const handleAddSecondBeneficiary = () => {
//     if (!showSecondBeneficiary) {
//       setShowSecondBeneficiary(true);
//     }
//   };

//   const handleSpousePromptResponse = (addSpouse) => {
//     setShowSpousePrompt(false);
//     if (addSpouse) {
//       setShowSpouseSection(true);
//       setCurrentStep(2);
//     } else {
//       setShowChildrenPrompt(true);
//     }
//   };

//   const handleSpouseSubmit = () => {
//     if (validateSpouseSection()) {
//       setCompletedSteps(prev => new Set([...prev, 2]));
//       setShowSpouseSection(false);
//       setShowChildrenPrompt(true);
//     } else {
//       toast.error('Please fill in all required spouse fields');
//     }
//   };

//   const handleChildrenPromptResponse = (addChildren) => {
//     setShowChildrenPrompt(false);
//     if (addChildren) {
//       setShowChildrenSection(true);
//       setCurrentStep(3);
//     } else {
//       setCurrentStep(4); // Go to final submission
//     }
//   };

//   const handleChildrenSubmit = () => {
//     if (validateChildrenSection()) {
//       setCompletedSteps(prev => new Set([...prev, 3]));
//       setShowChildrenSection(false);
//       setCurrentStep(4); // Go to final submission
//     } else {
//       toast.error('Please complete all children information');
//     }
//   };

//   const validateFinalSubmission = () => {
//     // Ensure exactly two beneficiaries are completed (mandatory)
//     if (
//       !formData.beneficiary_first_name ||
//       !formData.beneficiary_last_name ||
//       !formData.beneficiary2_first_name ||
//       !formData.beneficiary2_last_name
//     ) {
//       return false;
//     }
//     return true;
//   };

//   // Navigation handlers for editing sections from summary
//   const handleEditSection = (sectionStep) => {
//     switch(sectionStep) {
//       case 0: // Applicant
//         setCurrentStep(0);
//         break;
//       case 1: // Beneficiary
//         setShowBeneficiarySection(true);
//         setCurrentStep(1);
//         break;
//       case 2: // Spouse
//         setShowSpouseSection(true);
//         setCurrentStep(2);
//         break;
//       case 3: // Children
//         setShowChildrenSection(true);
//         setCurrentStep(3);
//         break;
//       default:
//         break;
//     }
//   };

//   // Back button handlers
//   const handleBackFromBeneficiary = () => {
//     setShowBeneficiarySection(false);
//     setCurrentStep(0);
//   };

//   const handleBackFromSpouse = () => {
//     setShowSpouseSection(false);
//     // Go back to beneficiary or show prompt
//     setShowBeneficiarySection(true);
//     setCurrentStep(1);
//   };

//   const handleBackFromChildren = () => {
//     setShowChildrenSection(false);
//     // Check if spouse section was filled
//     if (formData.spouse_first_name || formData.spouse_last_name || formData.marital_status !== 'Single') {
//       setShowSpouseSection(true);
//       setCurrentStep(2);
//     } else {
//       setShowBeneficiarySection(true);
//       setCurrentStep(1);
//     }
//   };

//   const handleBackFromSummary = () => {
//     // Go back to the last filled section
//     if (formData.children.some(child => child.first_name || child.last_name)) {
//       setShowChildrenSection(true);
//       setCurrentStep(3);
//     } else if (formData.spouse_first_name || formData.spouse_last_name) {
//       setShowSpouseSection(true);
//       setCurrentStep(2);
//     } else {
//       setShowBeneficiarySection(true);
//       setCurrentStep(1);
//     }
//   };

//   const handleFinalSubmit = async () => {
//     if (!validateFinalSubmission()) {
//       return;
//     }

//     try {
//       // Filter out empty children
//       const validChildren = formData.children.filter(child => 
//         child.first_name || child.middle_name || child.last_name || child.relationship || child.gender || child.disabled || child.dob
//       );

//       const submissionData = {
//         applicant: {
//           first_name: formData.first_name,
//           middle_name: formData.middle_name,
//           last_name: formData.last_name,
//           dob: formData.dob,
//           email: formData.email,
//           phone: formData.phone,
//           address: formData.address,
//           apt: formData.apt,
//           city: formData.city,
//           state: formData.state,
//           zip: formData.zip,
//           marital_status: formData.marital_status
//         },
//         beneficiary: {
//           first_name: formData.beneficiary_first_name,
//           middle_name: formData.beneficiary_middle_name,
//           last_name: formData.beneficiary_last_name,
//           phone: formData.beneficiary_phone,
//           address: formData.beneficiary_address,
//           apt: formData.beneficiary_apt,
//           city: formData.beneficiary_city,
//           state: formData.beneficiary_state,
//           zip: formData.beneficiary_zip
//         },
//         // Second beneficiary (frontend-enforced, backend will ignore if not supported)
//         beneficiary2: {
//           first_name: formData.beneficiary2_first_name,
//           middle_name: formData.beneficiary2_middle_name,
//           last_name: formData.beneficiary2_last_name,
//           phone: formData.beneficiary2_phone,
//           address: formData.beneficiary2_address,
//           apt: formData.beneficiary2_apt,
//           city: formData.beneficiary2_city,
//           state: formData.beneficiary2_state,
//           zip: formData.beneficiary2_zip
//         },
//         spouse: (formData.spouse_first_name || formData.spouse_last_name) ? {
//           first_name: formData.spouse_first_name,
//           middle_name: formData.spouse_middle_name,
//           last_name: formData.spouse_last_name,
//           dob: formData.spouse_dob,
//           email: formData.spouse_email,
//           phone: formData.spouse_phone
//         } : null,
//         children: validChildren,
//         signature: {
//           date: new Date().toISOString()
//         },
//         createdAt: new Date().toISOString()
//       };

//       // Make the API call using the service
//       const response = await becomeMemberServices.submitApplication(submissionData);
      
//       if (response.data.success) {
//         toast.success('Application submitted successfully!');
        
//         // Reset form and state
//         setFormData({
//           first_name: '', middle_name: '', last_name: '', dob: '', email: '', phone: '',
//           address: '', apt: '', city: '', state: '', zip: '', marital_status: '',
//           beneficiary_first_name: '', beneficiary_middle_name: '', beneficiary_last_name: '',
//           beneficiary_phone: '', beneficiary_address: '', beneficiary_apt: '', beneficiary_city: '', beneficiary_state: '', beneficiary_zip: '',
//           beneficiary2_first_name: '', beneficiary2_middle_name: '', beneficiary2_last_name: '',
//           beneficiary2_phone: '', beneficiary2_address: '', beneficiary2_apt: '', beneficiary2_city: '', beneficiary2_state: '', beneficiary2_zip: '',
//           spouse_first_name: '', spouse_middle_name: '', spouse_last_name: '', spouse_dob: '', spouse_email: '', spouse_phone: '',
//           children: [{ first_name: '', middle_name: '', last_name: '', relationship: '', gender: '', disabled: '', dob: '' }]
//         });
        
//         // Reset all state
//         setCurrentStep(0);
//         setCompletedSteps(new Set());
//         setShowBeneficiaryPrompt(false);
//         setShowSpousePrompt(false);
//         setShowChildrenPrompt(false);
//         setShowBeneficiarySection(false);
//         setShowSpouseSection(false);
//         setShowChildrenSection(false);
//         setShowSecondBeneficiary(false);
//         setShowBeneficiaryCountError(false);
//         setChildCount(1);
//         setMaritalStatus('');
//         setErrors({});
        
//       } else {
//         throw new Error(response.data.message || 'Failed to submit application');
//       }
      
//     } catch (error) {
//       console.error('Error submitting application:', error);
//       toast.error(error.message || 'Failed to submit application. Please try again.');
//     }
//   };

//   return (
//     <Box className="membership-form-container" sx={{ maxWidth: 1200, mx: 'auto', p: { xs: 2, md: 3 } }}>
//       {/* PDF Download Button at the top */}
//       <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
//         <Button 
//           variant="contained" 
//           onClick={handleDownloadPDF}
//           disabled={isGeneratingPDF}
//           sx={{ 
//             backgroundColor: '#28a745',
//             '&:hover': { backgroundColor: '#218838' },
//             '&:disabled': { backgroundColor: '#6c757d' },
//             fontWeight: 'bold',
//             fontSize: '16px',
//             padding: '10px 20px',
//             borderRadius: '8px'
//           }}
//         >
//           {isGeneratingPDF ? '⏳ Generating PDF...' : '📄 Download PDF'}
//         </Button>
//       </Box>

//       {/* Step-by-step form header */}
//       <Box className="form-header-with-logos" sx={{ mb: 4 }}>
//         <img src={Logo} alt="Hamsa Lomi Logo" className="header-logo left-logo" />
//         <Box className="header-center">
//           <Typography variant="h6" className="amharic-text" sx={{ fontSize: { xs: '0.9rem', md: '1.25rem' } }}>
//             ሃምሳ ሎሚ የኢትዮያውያን ማህበር - ናሽቪል - ቴነሲ
//           </Typography>
//           <Typography variant="h4" className="membership-form-title" sx={{ fontSize: { xs: '1.5rem', md: '2.125rem' } }}>
//             HAMSA LOMI ETHIOPIAN ASSOCIATION MEMBERSHIP APPLICATION
//           </Typography>
//         </Box>
//         <img src={Logo} alt="Hamsa Lomi Logo" className="header-logo right-logo" />
//       </Box>

//       {/* Step Progress Indicator */}
//       <Box sx={{ width: '100%', mb: 4 }}>
//         <Stepper 
//           activeStep={currentStep} 
//           alternativeLabel={!isMobile}
//           orientation={isMobile ? 'vertical' : 'horizontal'}
//           sx={{
//             '& .MuiStepLabel-root .Mui-completed': {
//               color: '#4caf50',
//             },
//             '& .MuiStepLabel-root .Mui-active': {
//               color: '#2196f3',
//             },
//             '& .MuiStepLabel-label': {
//               fontSize: { xs: '0.75rem', sm: '0.875rem' },
//             },
//           }}
//         >
//           {steps.map((label, index) => (
//             <Step key={label} completed={completedSteps.has(index)}>
//               <StepLabel>{label}</StepLabel>
//             </Step>
//           ))}
//         </Stepper>
//       </Box>

//       {/* Step 1: Applicant Information */}
//       {currentStep === 0 && (
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>
//               APPLICANT INFORMATION
//             </Typography>
//             <table className="form-table">
//               <tbody>
//                 <tr>
//                   <td width="33%">
//                     First Name: 
//                     <input 
//                       type="text" 
//                       name="first_name" 
//                       value={formData.first_name}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.first_name && <div className="error">{errors.first_name}</div>}
//                   </td>
//                   <td width="33%">
//                     Middle Name: 
//                     <input 
//                       type="text" 
//                       name="middle_name" 
//                       value={formData.middle_name}
//                       onChange={handleInputChange}
//                     />
//                   </td>
//                   <td width="33%">
//                     Last Name: 
//                     <input 
//                       type="text" 
//                       name="last_name" 
//                       value={formData.last_name}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.last_name && <div className="error">{errors.last_name}</div>}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>
//                     Date of birth: 
//                     <input 
//                       type="date" 
//                       name="dob" 
//                       value={formData.dob}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.dob && <div className="error">{errors.dob}</div>}
//                   </td>
//                   <td>
//                     E-Mail: 
//                     <input 
//                       type="email" 
//                       name="email" 
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.email && <div className="error">{errors.email}</div>}
//                   </td>
//                   <td>
//                     Phone: 
//                     <input 
//                       type="tel" 
//                       name="phone" 
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       placeholder="XXX-YYY-ZZZZ"
//                       maxLength={12}
//                       required 
//                     />
//                     {errors.phone && <div className="error">{errors.phone}</div>}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan="2">
//                     Current address: 
//                     <input 
//                       type="text" 
//                       name="address" 
//                       value={formData.address}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.address && <div className="error">{errors.address}</div>}
//                   </td>
//                   <td>
//                     Apt. #: 
//                     <input 
//                       type="text" 
//                       name="apt" 
//                       value={formData.apt}
//                       onChange={handleInputChange}
//                     />
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>
//                     City: 
//                     <input 
//                       type="text" 
//                       name="city" 
//                       value={formData.city}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.city && <div className="error">{errors.city}</div>}
//                   </td>
//                   <td>
//                     State: 
//                     <input 
//                       type="text" 
//                       name="state" 
//                       value={formData.state}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.state && <div className="error">{errors.state}</div>}
//                   </td>
//                   <td>
//                     Zip: 
//                     <input 
//                       type="text" 
//                       name="zip" 
//                       value={formData.zip}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.zip && <div className="error">{errors.zip}</div>}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>
//                     Marital Status: 
//                     <select 
//                       name="marital_status" 
//                       value={formData.marital_status}
//                       onChange={handleInputChange}
//                       required
//                     >
//                       <option value="">Select...</option>
//                       <option value="Single">Single</option>
//                       <option value="Married">Married</option>
//                       <option value="Divorced">Divorced</option>
//                       <option value="Widowed">Widowed</option>
//                     </select>
//                     {errors.marital_status && <div className="error">{errors.marital_status}</div>}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
            
//             <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
//               <Button 
//                 variant="contained" 
//                 onClick={handleApplicantSubmit}
//                 sx={{ 
//                   minWidth: 120,
//                   backgroundColor: '#28a745',
//                   '&:hover': { backgroundColor: '#218838' },
//                   fontWeight: 'bold'
//                 }}
//               >
//                 Continue
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       )}

//       {/* Beneficiary Prompt Dialog */}
//       <Dialog open={showBeneficiaryPrompt} onClose={() => {}} maxWidth="sm" fullWidth>
//         <DialogTitle>Add Beneficiary</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Would you like to add a Beneficiary? A beneficiary is required to proceed with your application.
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => handleBeneficiaryPromptResponse(false)} color="secondary">
//             No
//           </Button>
//           <Button 
//             onClick={() => handleBeneficiaryPromptResponse(true)} 
//             variant="contained"
//             sx={{ 
//               backgroundColor: '#28a745',
//               '&:hover': { backgroundColor: '#218838' },
//               fontWeight: 'bold'
//             }}
//           >
//             Yes, Add Beneficiary
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Beneficiary count validation dialog */}
//       <Dialog open={showBeneficiaryCountError} onClose={() => setShowBeneficiaryCountError(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Beneficiaries Required</DialogTitle>
//         <DialogContent>
//           <Typography>
//             You must add exactly Primary and Contingent beneficiaries before continuing. Please use the &quot;Add Beneficiary&quot; button to add a second Contingent beneficiary.
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             onClick={() => setShowBeneficiaryCountError(false)}
//             variant="contained"
//             sx={{
//               backgroundColor: '#28a745',
//               '&:hover': { backgroundColor: '#218838' },
//               fontWeight: 'bold'
//             }}
//           >
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Step 2: Beneficiary Information */}
//       {showBeneficiarySection && (
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>
//               BENEFICIARY INFORMATION
//             </Typography>
//             {/* Beneficiary 1 */}
//             <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
//              Primary Beneficiary 
//             </Typography>
//             <table className="form-table">
//               <tbody>
//                 <tr>
//                   <td width="33%">
//                     First Name: 
//                     <input 
//                       type="text" 
//                       name="beneficiary_first_name" 
//                       value={formData.beneficiary_first_name}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.beneficiary_first_name && <div className="error">{errors.beneficiary_first_name}</div>}
//                   </td>
//                   <td width="33%">
//                     Middle Name: 
//                     <input 
//                       type="text" 
//                       name="beneficiary_middle_name" 
//                       value={formData.beneficiary_middle_name}
//                       onChange={handleInputChange}
//                     />
//                   </td>
//                   <td width="33%">
//                     Last Name: 
//                     <input 
//                       type="text" 
//                       name="beneficiary_last_name" 
//                       value={formData.beneficiary_last_name}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.beneficiary_last_name && <div className="error">{errors.beneficiary_last_name}</div>}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan="3">
//                     Phone: 
//                     <input 
//                       type="tel" 
//                       name="beneficiary_phone" 
//                       value={formData.beneficiary_phone}
//                       onChange={handleInputChange}
//                       placeholder="XXX-YYY-ZZZZ"
//                       maxLength={12}
//                     />
//                     {errors.beneficiary_phone && <div className="error">{errors.beneficiary_phone}</div>}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan="2">
//                     Address: 
//                     <input 
//                       type="text" 
//                       name="beneficiary_address" 
//                       value={formData.beneficiary_address}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.beneficiary_address && <div className="error">{errors.beneficiary_address}</div>}
//                   </td>
//                   <td>
//                     Apt. #: 
//                     <input 
//                       type="text" 
//                       name="beneficiary_apt" 
//                       value={formData.beneficiary_apt}
//                       onChange={handleInputChange}
//                     />
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>
//                     City: 
//                     <input 
//                       type="text" 
//                       name="beneficiary_city" 
//                       value={formData.beneficiary_city}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.beneficiary_city && <div className="error">{errors.beneficiary_city}</div>}
//                   </td>
//                   <td>
//                     State: 
//                     <input 
//                       type="text" 
//                       name="beneficiary_state" 
//                       value={formData.beneficiary_state}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.beneficiary_state && <div className="error">{errors.beneficiary_state}</div>}
//                   </td>
//                   <td>
//                     Zip: 
//                     <input 
//                       type="text" 
//                       name="beneficiary_zip" 
//                       value={formData.beneficiary_zip}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.beneficiary_zip && <div className="error">{errors.beneficiary_zip}</div>}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>

//             {/* Beneficiary 2 */}
//             {showSecondBeneficiary && (
//               <React.Fragment>
//                 <Box sx={{ mt: 4, mb: 1 }}>
//                   <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
//                     Contingent Beneficiary 
//                   </Typography>
//                 </Box>
//                 <table className="form-table">
//                   <tbody>
//                     <tr>
//                       <td width="33%">
//                         First Name: 
//                         <input 
//                           type="text" 
//                           name="beneficiary2_first_name" 
//                           value={formData.beneficiary2_first_name}
//                           onChange={handleInputChange}
//                           required 
//                         />
//                         {errors.beneficiary2_first_name && <div className="error">{errors.beneficiary2_first_name}</div>}
//                       </td>
//                       <td width="33%">
//                         Middle Name: 
//                         <input 
//                           type="text" 
//                           name="beneficiary2_middle_name" 
//                           value={formData.beneficiary2_middle_name}
//                           onChange={handleInputChange}
//                         />
//                       </td>
//                       <td width="33%">
//                         Last Name: 
//                         <input 
//                           type="text" 
//                           name="beneficiary2_last_name" 
//                           value={formData.beneficiary2_last_name}
//                           onChange={handleInputChange}
//                           required 
//                         />
//                         {errors.beneficiary2_last_name && <div className="error">{errors.beneficiary2_last_name}</div>}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td colSpan="3">
//                         Phone: 
//                         <input 
//                           type="tel" 
//                           name="beneficiary2_phone" 
//                           value={formData.beneficiary2_phone}
//                           onChange={handleInputChange}
//                           placeholder="XXX-YYY-ZZZZ"
//                           maxLength={12}
//                         />
//                         {errors.beneficiary2_phone && <div className="error">{errors.beneficiary2_phone}</div>}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td colSpan="2">
//                         Address: 
//                         <input 
//                           type="text" 
//                           name="beneficiary2_address" 
//                           value={formData.beneficiary2_address}
//                           onChange={handleInputChange}
//                           required 
//                         />
//                         {errors.beneficiary2_address && <div className="error">{errors.beneficiary2_address}</div>}
//                       </td>
//                       <td>
//                         Apt. #: 
//                         <input 
//                           type="text" 
//                           name="beneficiary2_apt" 
//                           value={formData.beneficiary2_apt}
//                           onChange={handleInputChange}
//                         />
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>
//                         City: 
//                         <input 
//                           type="text" 
//                           name="beneficiary2_city" 
//                           value={formData.beneficiary2_city}
//                           onChange={handleInputChange}
//                           required 
//                         />
//                         {errors.beneficiary2_city && <div className="error">{errors.beneficiary2_city}</div>}
//                       </td>
//                       <td>
//                         State: 
//                         <input 
//                           type="text" 
//                           name="beneficiary2_state" 
//                           value={formData.beneficiary2_state}
//                           onChange={handleInputChange}
//                           required 
//                         />
//                         {errors.beneficiary2_state && <div className="error">{errors.beneficiary2_state}</div>}
//                       </td>
//                       <td>
//                         Zip: 
//                         <input 
//                           type="text" 
//                           name="beneficiary2_zip" 
//                           value={formData.beneficiary2_zip}
//                           onChange={handleInputChange}
//                           required 
//                         />
//                         {errors.beneficiary2_zip && <div className="error">{errors.beneficiary2_zip}</div>}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </React.Fragment>
//             )}
            
//             <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', rowGap: 2 }}>
//               <Box sx={{ display: 'flex', gap: 2 }}>
//                 <Button 
//                   variant="contained" 
//                   onClick={handleBackFromBeneficiary}
//                   sx={{ 
//                     minWidth: 120,
//                     backgroundColor: '#6c757d',
//                     color: '#fff',
//                     '&:hover': { 
//                       backgroundColor: '#5a6268'
//                     }
//                   }}
//                 >
//                   Back
//                 </Button>
//                 {!showSecondBeneficiary && (
//                   <Button
//                     variant="outlined"
//                     onClick={handleAddSecondBeneficiary}
//                     sx={{
//                       minWidth: 160,
//                       borderColor: '#28a745',
//                       color: '#28a745',
//                       '&:hover': { borderColor: '#218838', color: '#218838' },
//                       fontWeight: 'bold'
//                     }}
//                   >
//                     Add Beneficiary
//                   </Button>
//                 )}
//               </Box>
//               <Button 
//                 variant="contained" 
//                 onClick={handleBeneficiarySubmit}
//                 sx={{ 
//                   minWidth: 120,
//                   backgroundColor: '#28a745',
//                   '&:hover': { backgroundColor: '#218838' },
//                   fontWeight: 'bold'
//                 }}
//               >
//                 Continue
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       )}

//       {/* Spouse Prompt Dialog */}
//       <Dialog open={showSpousePrompt} onClose={() => {}} maxWidth="sm" fullWidth>
//         <DialogTitle>Add Spouse</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Would you like to add Spouse information to your application?
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => handleSpousePromptResponse(false)} color="secondary">
//             No, Skip
//           </Button>
//           <Button 
//             onClick={() => handleSpousePromptResponse(true)} 
//             variant="contained"
//             sx={{ 
//               backgroundColor: '#28a745',
//               '&:hover': { backgroundColor: '#218838' },
//               fontWeight: 'bold'
//             }}
//           >
//             Yes, Add Spouse
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Step 3: Spouse Information */}
//       {showSpouseSection && (
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>
//               SPOUSE INFORMATION
//             </Typography>
//             <table className="form-table">
//               <tbody>
//                 <tr>
//                   <td width="33%">
//                     First Name: 
//                     <input 
//                       type="text" 
//                       name="spouse_first_name" 
//                       value={formData.spouse_first_name}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.spouse_first_name && <div className="error">{errors.spouse_first_name}</div>}
//                   </td>
//                   <td width="33%">
//                     Middle Name: 
//                     <input 
//                       type="text" 
//                       name="spouse_middle_name" 
//                       value={formData.spouse_middle_name}
//                       onChange={handleInputChange}
//                     />
//                   </td>
//                   <td width="33%">
//                     Last Name: 
//                     <input 
//                       type="text" 
//                       name="spouse_last_name" 
//                       value={formData.spouse_last_name}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.spouse_last_name && <div className="error">{errors.spouse_last_name}</div>}
//                   </td>
//                 </tr>
//                 <tr>
//                   <td>
//                     Date of birth: 
//                     <input 
//                       type="date" 
//                       name="spouse_dob" 
//                       value={formData.spouse_dob}
//                       onChange={handleInputChange}
//                       required 
//                     />
//                     {errors.spouse_dob && <div className="error">{errors.spouse_dob}</div>}
//                   </td>
//                   <td>
//                     E-Mail: 
//                     <input 
//                       type="email" 
//                       name="spouse_email" 
//                       value={formData.spouse_email}
//                       onChange={handleInputChange}
//                     />
//                     {errors.spouse_email && <div className="error">{errors.spouse_email}</div>}
//                   </td>
//                   <td>
//                     Phone: 
//                     <input 
//                       type="tel" 
//                       name="spouse_phone" 
//                       value={formData.spouse_phone}
//                       onChange={handleInputChange}
//                       placeholder="XXX-YYY-ZZZZ"
//                       maxLength={12}
//                     />
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
            
//             <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
//               <Button 
//                 variant="contained" 
//                 onClick={handleBackFromSpouse}
//                 sx={{ 
//                   minWidth: 120,
//                   backgroundColor: '#6c757d',
//                   color: '#fff',
//                   '&:hover': { 
//                     backgroundColor: '#5a6268'
//                   }
//                 }}
//               >
//                 Back
//               </Button>
//               <Button 
//                 variant="contained" 
//                 onClick={handleSpouseSubmit}
//                 sx={{ 
//                   minWidth: 120,
//                   backgroundColor: '#28a745',
//                   '&:hover': { backgroundColor: '#218838' },
//                   fontWeight: 'bold'
//                 }}
//               >
//                 Continue
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       )}

//       {/* Children Prompt Dialog */}
//       <Dialog open={showChildrenPrompt} onClose={() => {}} maxWidth="sm" fullWidth>
//         <DialogTitle>Add Children</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Would you like to add Children information to your application?
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => handleChildrenPromptResponse(false)} color="secondary">
//             No, Skip
//           </Button>
//           <Button 
//             onClick={() => handleChildrenPromptResponse(true)} 
//             variant="contained"
//             sx={{ 
//               backgroundColor: '#28a745',
//               '&:hover': { backgroundColor: '#218838' },
//               fontWeight: 'bold'
//             }}
//           >
//             Yes, Add Children
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Step 4: Children Information */}
//       {showChildrenSection && (
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>
//               CHILDREN INFORMATION
//             </Typography>
            
//             {formData.children.map((child, index) => {
//               return (
//               <Box key={index} sx={{ mb: 3, p: 2, border: '1px solid #ddd', borderRadius: 1 }}>
//                 <Typography variant="h6" sx={{ mb: 2, fontSize: { xs: '1rem', md: '1.25rem' } }}>
//                   Child {index + 1}
//                   {childCount > 1 && (
//                     <Button 
//                       onClick={() => removeChild(index)} 
//                       color="error" 
//                       size="small" 
//                       sx={{ ml: 2 }}
//                     >
//                       Remove
//                     </Button>
//                   )}
//                 </Typography>
                
//                 <table className="form-table">
//                   <tbody>
//                     <tr>
//                       <td width="33%">
//                         First Name: 
//                         <input 
//                           type="text" 
//                           value={child.first_name}
//                           onChange={(e) => handleChildChange(index, 'first_name', e.target.value)}
//                         />
//                         {errors[`child${index}_first_name`] && <div className="error">{errors[`child${index}_first_name`]}</div>}
//                       </td>
//                       <td width="33%">
//                         Middle Name: 
//                         <input 
//                           type="text" 
//                           value={child.middle_name}
//                           onChange={(e) => handleChildChange(index, 'middle_name', e.target.value)}
//                         />
//                         {errors[`child${index}_middle_name`] && <div className="error">{errors[`child${index}_middle_name`]}</div>}
//                       </td>
//                       <td width="34%">
//                         Last Name: 
//                         <input 
//                           type="text" 
//                           value={child.last_name}
//                           onChange={(e) => handleChildChange(index, 'last_name', e.target.value)}
//                         />
//                         {errors[`child${index}_last_name`] && <div className="error">{errors[`child${index}_last_name`]}</div>}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td colspan="3">
//                         Relationship: 
//                         <select 
//                           value={child.relationship}
//                           onChange={(e) => handleChildChange(index, 'relationship', e.target.value)}
//                         >
//                           <option value="">Select...</option>
//                           <option value="Son">Son</option>
//                           <option value="Daughter">Daughter</option>
//                           <option value="Stepson">Stepson</option>
//                           <option value="Stepdaughter">Stepdaughter</option>
//                         </select>
//                         {errors[`child${index}_relationship`] && <div className="error">{errors[`child${index}_relationship`]}</div>}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>
//                         Gender: 
//                         <select 
//                           value={child.gender}
//                           onChange={(e) => handleChildChange(index, 'gender', e.target.value)}
//                         >
//                           <option value="">Select...</option>
//                           <option value="Male">Male</option>
//                           <option value="Female">Female</option>
//                         </select>
//                         {errors[`child${index}_gender`] && <div className="error">{errors[`child${index}_gender`]}</div>}
//                       </td>
//                       <td>
//                         Date of birth: 
//                         <input 
//                           type="date" 
//                           value={child.dob}
//                           onChange={(e) => handleChildChange(index, 'dob', e.target.value)}
//                         />
//                         {errors[`child${index}_dob`] && <div className="error">{errors[`child${index}_dob`]}</div>}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>
//                         Disabled: 
//                         <select 
//                           value={child.disabled}
//                           onChange={(e) => handleChildChange(index, 'disabled', e.target.value)}
//                         >
//                           <option value="">Select...</option>
//                           <option value="Yes">Yes</option>
//                           <option value="No">No</option>
//                         </select>
//                         {errors[`child${index}_disabled`] && <div className="error">{errors[`child${index}_disabled`]}</div>}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </Box>
//             )})}
            
//             {childCount < 7 && (
//               <Button 
//                 variant="outlined" 
//                 onClick={addChild} 
//                 sx={{ 
//                   mb: 3,
//                   borderColor: '#28a745',
//                   color: '#28a745',
//                   '&:hover': { 
//                     borderColor: '#218838',
//                     backgroundColor: 'rgba(40, 167, 69, 0.04)'
//                   }
//                 }}
//               >
//                 Add Another Child
//               </Button>
//             )}
            
//             <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
//               <Button 
//                 variant="contained" 
//                 onClick={handleBackFromChildren}
//                 sx={{ 
//                   minWidth: 120,
//                   backgroundColor: '#6c757d',
//                   color: '#fff',
//                   '&:hover': { 
//                     backgroundColor: '#5a6268'
//                   }
//                 }}
//               >
//                 Back
//               </Button>
//               <Button 
//                 variant="contained" 
//                 onClick={handleChildrenSubmit}
//                 sx={{ 
//                   minWidth: 120,
//                   backgroundColor: '#28a745',
//                   '&:hover': { backgroundColor: '#218838' },
//                   fontWeight: 'bold'
//                 }}
//               >
//                 Continue
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       )}

//       {/* Step 5: Review & Submit */}
//       {currentStep === 4 && (
//         <Card sx={{ mb: 3 }}>
//           <CardContent>
//             <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>
//               REVIEW & SUBMIT APPLICATION
//             </Typography>
            
//             <Typography variant="h6" sx={{ mb: 2 }}>Application Summary:</Typography>
            
//             <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, position: 'relative' }}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                 <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Applicant Information</Typography>
//                 <Button 
//                   size="small" 
//                   variant="outlined"
//                   onClick={() => handleEditSection(0)}
//                   sx={{ 
//                     borderColor: '#2196f3',
//                     color: '#2196f3',
//                     '&:hover': { 
//                       borderColor: '#1976d2',
//                       backgroundColor: 'rgba(33, 150, 243, 0.04)'
//                     }
//                   }}
//                 >
//                   Edit
//                 </Button>
//               </Box>
//               <Typography>{formData.first_name} {formData.middle_name} {formData.last_name}</Typography>
//               <Typography>DOB: {formData.dob}</Typography>
//               <Typography>{formData.email} | {formData.phone}</Typography>
//               <Typography>{formData.address}{formData.apt ? `, Apt ${formData.apt}` : ''}, {formData.city}, {formData.state} {formData.zip}</Typography>
//               <Typography>Marital Status: {formData.marital_status}</Typography>
//             </Box>

//             <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, position: 'relative' }}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                 <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Beneficiary Information</Typography>
//                 <Button 
//                   size="small" 
//                   variant="outlined"
//                   onClick={() => handleEditSection(1)}
//                   sx={{ 
//                     borderColor: '#2196f3',
//                     color: '#2196f3',
//                     '&:hover': { 
//                       borderColor: '#1976d2',
//                       backgroundColor: 'rgba(33, 150, 243, 0.04)'
//                     }
//                   }}
//                 >
//                   Edit
//                 </Button>
//               </Box>

//               {/* Beneficiary 1 summary */}
//               <Typography sx={{ fontWeight: 'bold', mb: 0.5 }}>Primary Beneficiary </Typography>
//               <Typography>{formData.beneficiary_first_name} {formData.beneficiary_middle_name} {formData.beneficiary_last_name}</Typography>
//               <Typography>Phone: {formData.beneficiary_phone}</Typography>
//               <Typography sx={{ mb: 2 }}>
//                 {formData.beneficiary_address}
//                 {formData.beneficiary_apt ? `, Apt ${formData.beneficiary_apt}` : ''}, {formData.beneficiary_city}, {formData.beneficiary_state} {formData.beneficiary_zip}
//               </Typography>

//               {/* Beneficiary 2 summary */}
//               <Typography sx={{ fontWeight: 'bold', mb: 0.5 }}>Contingent Beneficiary </Typography>
//               <Typography>{formData.beneficiary2_first_name} {formData.beneficiary2_middle_name} {formData.beneficiary2_last_name}</Typography>
//               <Typography>Phone: {formData.beneficiary2_phone}</Typography>
//               <Typography>
//                 {formData.beneficiary2_address}
//                 {formData.beneficiary2_apt ? `, Apt ${formData.beneficiary2_apt}` : ''}, {formData.beneficiary2_city}, {formData.beneficiary2_state} {formData.beneficiary2_zip}
//               </Typography>
//             </Box>

//             {(formData.spouse_first_name || formData.spouse_last_name) && (
//               <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, position: 'relative' }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                   <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Spouse Information</Typography>
//                   <Button 
//                     size="small" 
//                     variant="outlined"
//                     onClick={() => handleEditSection(2)}
//                     sx={{ 
//                       borderColor: '#2196f3',
//                       color: '#2196f3',
//                       '&:hover': { 
//                         borderColor: '#1976d2',
//                         backgroundColor: 'rgba(33, 150, 243, 0.04)'
//                       }
//                     }}
//                   >
//                     Edit
//                   </Button>
//                 </Box>
//                 <Typography>{formData.spouse_first_name} {formData.spouse_middle_name} {formData.spouse_last_name}</Typography>
//                 <Typography>DOB: {formData.spouse_dob}</Typography>
//                 <Typography>{formData.spouse_email} | {formData.spouse_phone}</Typography>
//               </Box>
//             )}

//             {formData.children.some(child => child.first_name || child.last_name) && (
//               <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, position: 'relative' }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                   <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Children Information</Typography>
//                   <Button 
//                     size="small" 
//                     variant="outlined"
//                     onClick={() => handleEditSection(3)}
//                     sx={{ 
//                       borderColor: '#2196f3',
//                       color: '#2196f3',
//                       '&:hover': { 
//                         borderColor: '#1976d2',
//                         backgroundColor: 'rgba(33, 150, 243, 0.04)'
//                       }
//                     }}
//                   >
//                     Edit
//                   </Button>
//                 </Box>
//                 {formData.children.filter(child => child.first_name || child.last_name).map((child, index) => (
//                   <Typography key={index}>
//                     {`${child.first_name || ''} ${child.middle_name ? child.middle_name + ' ' : ''}${child.last_name || ''}`.trim()} - {child.relationship} ({child.gender}, DOB: {child.dob}, Disabled: {child.disabled})
//                   </Typography>
//                 ))}
//               </Box>
//             )}
            
//             <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <Button 
//                 variant="contained" 
//                 onClick={handleBackFromSummary}
//                 sx={{ 
//                   minWidth: 120,
//                   backgroundColor: '#6c757d',
//                   color: '#fff',
//                   '&:hover': { 
//                     backgroundColor: '#5a6268'
//                   }
//                 }}
//               >
//                 Back
//               </Button>
//               <Button 
//                 variant="contained" 
//                 onClick={handleFinalSubmit}
//                 size="large"
//                 sx={{ 
//                   minWidth: 200, 
//                   fontSize: '1.1rem',
//                   backgroundColor: '#28a745',
//                   '&:hover': { backgroundColor: '#218838' },
//                   fontWeight: 'bold',
//                   padding: '12px 24px'
//                 }}
//               >
//                 Submit Application
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       )}
//     </Box>
//   );
// };

// export default StepByStepMembershipForm;

import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Stepper, 
  Step, 
  StepLabel, 
  Card, 
  CardContent, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { toast } from 'react-toastify';
import { Document, Page, Text, View, StyleSheet, Image, pdf, Font } from '@react-pdf/renderer';
import './MembershipForm.css';
import Logo from '../../assets/updated_hamsa_logo_transparent.png';
import becomeMemberServices from '../../services/becomeMemberServices';
import EthiopicFont from '../../../src/static/NotoSansEthiopic-Bold.ttf';

Font.register({ family: 'NotoSansEthiopic', src: EthiopicFont });

const StepByStepMembershipForm = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const pdfStyles = StyleSheet.create({
    page: {
      flexDirection: 'column', backgroundColor: '#FFFFFF',
      padding: 20, fontSize: 9, fontFamily: 'Helvetica',
    },
    header: {
      flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
      marginBottom: 15, borderBottom: '2px solid #000000', paddingBottom: 10,
    },
    logo: { width: 50, height: 50 },
    headerCenter: { flex: 1, textAlign: 'center', paddingHorizontal: 10 },
    amharicTitle: {
      fontSize: 10, fontWeight: 'bold', marginBottom: 3,
      fontFamily: 'NotoSansEthiopic', textAlign: 'center',
    },
    englishTitle: { fontSize: 11, fontWeight: 'bold', lineHeight: 1.2, textAlign: 'center' },
    section: { marginBottom: 6 },
    sectionTitle: {
      fontSize: 10, fontWeight: 'bold', textAlign: 'center', marginBottom: 6,
      textTransform: 'uppercase', borderBottom: '1px solid #000000', paddingBottom: 2,
    },
    row: { flexDirection: 'row', marginBottom: 4 },
    fieldThird: { flex: 0.33, marginRight: 8 },
    fieldHalf: { flex: 0.5, marginRight: 8 },
    fieldTwoThirds: { flex: 0.66, marginRight: 8 },
    fieldLabel: { fontSize: 8, fontWeight: 'bold', marginBottom: 1 },
    fieldValue: {
      borderBottom: '1px solid #000000', paddingBottom: 2, paddingTop: 2,
      minHeight: 12, fontSize: 8, paddingLeft: 2, paddingRight: 2,
    },
    childBox: { border: '1px solid #CCCCCC', marginBottom: 3, padding: 4 },
    childTitle: {
      fontSize: 8, fontWeight: 'bold', textAlign: 'center',
      marginBottom: 2, textDecoration: 'underline',
    },

    // ── Certification block ────────────────────────────────────────────────
    certBlock: { marginTop: 40, marginBottom: 8, border: '1px solid #000000', padding: 16 },
    certTitle: {
      fontSize: 9, fontWeight: 'bold', textAlign: 'center', marginBottom: 6,
      textTransform: 'uppercase', borderBottom: '1px solid #000000', paddingBottom: 2,
    },
    certBodyText: { fontSize: 8, marginBottom: 8, lineHeight: 1.6 },
    certAmharic: { fontSize: 8, marginBottom: 10, lineHeight: 1.6, fontFamily: 'NotoSansEthiopic' },

    // Short applicant sign fields
    certSignRow: { flexDirection: 'row', marginBottom: 10, alignItems: 'flex-end' },
    certSignLabel: { fontSize: 8, fontWeight: 'bold', marginRight: 6, minWidth: 90 },
    certSignLine: { width: 160, borderBottom: '1px solid #000000', height: 12 },

    // ── Notary block ───────────────────────────────────────────────────────
    notaryBlock: { marginTop: 8, borderTop: '1px solid #000000', paddingTop: 6 },
    notaryDivider: {
      fontSize: 9, fontWeight: 'bold', textAlign: 'center',
      marginBottom: 6, letterSpacing: 0.5,
    },

    // State / County row
    notaryTopRow: { flexDirection: 'row', marginBottom: 6 },
    notaryTopItem: { flexDirection: 'row', alignItems: 'flex-end', marginRight: 24 },
    notaryTopLabel: { fontSize: 8, marginRight: 3 },
    notaryTopLine: { width: 90, borderBottom: '1px solid #000000', height: 10 },

    // Paragraph text
    notaryPara: { fontSize: 8, lineHeight: 1.6, marginBottom: 5 },

    // Inline underline used inside paragraphs
    notaryBlank: { borderBottom: '1px solid #000000' },

    // Witness line row
    notaryWitnessRow: { flexDirection: 'row', alignItems: 'flex-end', marginBottom: 8, flexWrap: 'wrap' },
    notaryWitnessText: { fontSize: 8, marginRight: 2 },
    notaryWitnessLine: { borderBottom: '1px solid #000000', height: 10 },

    // Signature fields — label on left, short line on right
    notarySigRow: { flexDirection: 'row', alignItems: 'flex-end', marginBottom: 12 },
    notarySigLabel: { fontSize: 8, fontWeight: 'bold', minWidth: 120, marginRight: 4 },
    notarySigLine: { width: 200, borderBottom: '1px solid #000000', height: 10 },

    // SEAL row — inline with last sig field
    notarySealRow: { flexDirection: 'row', alignItems: 'flex-end', marginBottom: 12 },
    notarySealLabel: { fontSize: 8, fontWeight: 'bold', minWidth: 120, marginRight: 4 },
    notarySealLine: { width: 200, borderBottom: '1px solid #000000', height: 10, marginRight: 10 },
    notarySealText: { fontSize: 8, fontWeight: 'bold' },

    // Commission row
    notaryCommRow: { flexDirection: 'row', alignItems: 'flex-end', marginTop: 2 },
    notaryCommLabel: { fontSize: 8, fontWeight: 'bold', minWidth: 120, marginRight: 4 },
    notaryCommLine: { width: 120, borderBottom: '1px solid #000000', height: 10 },
  });

  const formatDate = (dateStr) => {
    if (!dateStr) return '___________________';
    try { return new Date(dateStr).toLocaleDateString('en-US'); }
    catch { return '___________________'; }
  };

  const createBlank = (value) => (value && value.trim() ? value.trim() : ' ');

  // ── PDF Document ───────────────────────────────────────────────────────────
  const MembershipPDF = ({ formData }) => (
    <Document>
      <Page size="A4" style={pdfStyles.page}>

        {/* Header */}
        <View style={pdfStyles.header}>
          <Image style={pdfStyles.logo} src={Logo} />
          <View style={pdfStyles.headerCenter}>
            <Text style={pdfStyles.amharicTitle}>ሃምሳ ሎሚ የኢትዮያውያን ማህበር - ናሽቪል - ቴነሲ</Text>
            <Text style={pdfStyles.englishTitle}>
              HAMSA LOMI ETHIOPIAN ASSOCIATION{'\n'}NASHVILLE, TENNESSEE{'\n'}MEMBERSHIP APPLICATION
            </Text>
          </View>
          <Image style={pdfStyles.logo} src={Logo} />
        </View>

        {/* Applicant Information */}
        <View style={pdfStyles.section}>
          <Text style={pdfStyles.sectionTitle}>APPLICANT INFORMATION</Text>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>First Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.first_name)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Middle Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.middle_name)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Last Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.last_name)}</Text></View>
          </View>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Date of Birth:</Text><Text style={pdfStyles.fieldValue}>{formatDate(formData.dob)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>E-Mail:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.email)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Phone:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.phone)}</Text></View>
          </View>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldTwoThirds}><Text style={pdfStyles.fieldLabel}>Current Address:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.address)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Apt. #:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.apt)}</Text></View>
          </View>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>City:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.city)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>State:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.state)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Zip:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.zip)}</Text></View>
          </View>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldHalf}><Text style={pdfStyles.fieldLabel}>Marital Status:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.marital_status)}</Text></View>
          </View>
        </View>

        {/* Beneficiary Information */}
        <View style={pdfStyles.section}>
          <Text style={pdfStyles.sectionTitle}>BENEFICIARY INFORMATION</Text>
          <View style={pdfStyles.childBox}>
            <Text style={pdfStyles.childTitle}>Beneficiary 1</Text>
            <View style={pdfStyles.row}>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>First Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_first_name)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Middle Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_middle_name)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Last Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_last_name)}</Text></View>
            </View>
            <View style={pdfStyles.row}><View style={pdfStyles.fieldHalf}><Text style={pdfStyles.fieldLabel}>Phone:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_phone)}</Text></View></View>
            <View style={pdfStyles.row}>
              <View style={pdfStyles.fieldTwoThirds}><Text style={pdfStyles.fieldLabel}>Address:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_address)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Apt. #:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_apt)}</Text></View>
            </View>
            <View style={pdfStyles.row}>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>City:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_city)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>State:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_state)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Zip:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary_zip)}</Text></View>
            </View>
          </View>

          <View style={pdfStyles.childBox}>
            <Text style={pdfStyles.childTitle}>Beneficiary 2</Text>
            <View style={pdfStyles.row}>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>First Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_first_name)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Middle Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_middle_name)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Last Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_last_name)}</Text></View>
            </View>
            <View style={pdfStyles.row}><View style={pdfStyles.fieldHalf}><Text style={pdfStyles.fieldLabel}>Phone:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_phone)}</Text></View></View>
            <View style={pdfStyles.row}>
              <View style={pdfStyles.fieldTwoThirds}><Text style={pdfStyles.fieldLabel}>Address:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_address)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Apt. #:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_apt)}</Text></View>
            </View>
            <View style={pdfStyles.row}>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>City:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_city)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>State:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_state)}</Text></View>
              <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Zip:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.beneficiary2_zip)}</Text></View>
            </View>
          </View>
        </View>

        {/* Spouse Information */}
        <View style={pdfStyles.section}>
          <Text style={pdfStyles.sectionTitle}>SPOUSE INFORMATION</Text>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>First Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_first_name)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Middle Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_middle_name)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Last Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_last_name)}</Text></View>
          </View>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Date of Birth:</Text><Text style={pdfStyles.fieldValue}>{formatDate(formData.spouse_dob)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>E-Mail:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_email)}</Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Phone:</Text><Text style={pdfStyles.fieldValue}>{createBlank(formData.spouse_phone)}</Text></View>
          </View>
        </View>

        {/* Children Information */}
        <View style={pdfStyles.section}>
          <Text style={pdfStyles.sectionTitle}>CHILDREN INFORMATION</Text>
          {Array.from({ length: 7 }, (_, index) => {
            const child = (formData.children && formData.children[index]) || {};
            return (
              <View key={index} style={pdfStyles.childBox}>
                <Text style={pdfStyles.childTitle}>Child {index + 1}</Text>
                <View style={pdfStyles.row}>
                  <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>First Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(child.first_name)}</Text></View>
                  <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Middle Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(child.middle_name)}</Text></View>
                  <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Last Name:</Text><Text style={pdfStyles.fieldValue}>{createBlank(child.last_name)}</Text></View>
                </View>
                <View style={pdfStyles.row}><View style={pdfStyles.fieldHalf}><Text style={pdfStyles.fieldLabel}>Relationship:</Text><Text style={pdfStyles.fieldValue}>{createBlank(child.relationship)}</Text></View></View>
                <View style={pdfStyles.row}>
                  <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Gender:</Text><Text style={pdfStyles.fieldValue}>{createBlank(child.gender)}</Text></View>
                  <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Date of Birth:</Text><Text style={pdfStyles.fieldValue}>{formatDate(child.dob)}</Text></View>
                  <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Disabled:</Text><Text style={pdfStyles.fieldValue}>{createBlank(child.disabled)}</Text></View>
                </View>
              </View>
            );
          })}
        </View>

        {/* ── Certification & Notary — keep together ── */}
        <View wrap={false} style={pdfStyles.certBlock}>
          <Text style={pdfStyles.certTitle}>CERTIFICATION &amp; NOTARIZATION</Text>

          {/* English certification text */}
          <Text style={pdfStyles.certBodyText}>
            I certify under penalty of perjury that the information provided in this application is true and correct to the best of my knowledge. I understand that any false or misleading statements may result in denial of membership, removal from the Association, and potential legal consequences if such misrepresentation constitutes fraud under applicable law.
          </Text>

          {/* Amharic certification text */}
          <Text style={pdfStyles.certAmharic}>
            በዚህ ማመልከቻ ውስጥ የቀረበው መረጃ እውነተኛ እና ትክክለኛ እንደሆነ አረጋግጣለሁ። ማንኛውም ሐሰተኛ ወይም አሳሳች መረጃ ከአባልነት እንደሚያሰርዘኝ እና በሀገሪቱ ሕግ እንደሚያስከስሰኝ በማወቅ ከላይ የሞላሁት ማመልከቻ ትክክለኛነት በፊርማዬ አረጋግጣለው።
          </Text>

          {/* Applicant Name */}
          <View style={pdfStyles.certSignRow}>
            <Text style={pdfStyles.certSignLabel}>
              <Text style={{ fontFamily: 'Helvetica' }}>Applicant Name / </Text>
              <Text style={{ fontFamily: 'NotoSansEthiopic' }}>ስም</Text>
              <Text style={{ fontFamily: 'Helvetica' }}>:</Text>
            </Text>
            <Text style={pdfStyles.certSignLine}> </Text>
          </View>

          {/* Signature */}
          <View style={pdfStyles.certSignRow}>
            <Text style={pdfStyles.certSignLabel}>
              <Text style={{ fontFamily: 'Helvetica' }}>Signature / </Text>
              <Text style={{ fontFamily: 'NotoSansEthiopic' }}>ፊርማ</Text>
              <Text style={{ fontFamily: 'Helvetica' }}>:</Text>
            </Text>
            <Text style={pdfStyles.certSignLine}> </Text>
          </View>

          {/* Date */}
          <View style={pdfStyles.certSignRow}>
            <Text style={pdfStyles.certSignLabel}>
              <Text style={{ fontFamily: 'Helvetica' }}>Date / </Text>
              <Text style={{ fontFamily: 'NotoSansEthiopic' }}>ቀን</Text>
              <Text style={{ fontFamily: 'Helvetica' }}>:</Text>
            </Text>
            <Text style={pdfStyles.certSignLine}> </Text>
          </View>

          {/* ── Notary section ── */}
          <View style={pdfStyles.notaryBlock}>
            <Text style={pdfStyles.notaryDivider}>
              -------------------- NOTARY PUBLIC --------------------
            </Text>

            {/* State of Tennessee / County of ___ */}
            <View style={pdfStyles.notaryTopRow}>
              <View style={pdfStyles.notaryTopItem}>
                <Text style={pdfStyles.notaryTopLabel}>State of</Text>
                <Text style={pdfStyles.notaryTopLine}> </Text>
              </View>
              <View style={pdfStyles.notaryTopItem}>
                <Text style={pdfStyles.notaryTopLabel}>County of</Text>
                <Text style={pdfStyles.notaryTopLine}> </Text>
              </View>
            </View>

            {/* Before me paragraph */}
            <Text style={pdfStyles.notaryPara}>
              {'Before me, the undersigned authority, personally appeared '}
              <Text style={[pdfStyles.notaryBlank, { fontSize: 8 }]}>{'                                        '}</Text>
              {',\nwith whom I am personally acquainted (or proved to me on the basis of satisfactory evidence),\nand who acknowledged that he/she executed the foregoing instrument for the purposes therein contained.'}
            </Text>

            {/* Witness line */}
            <View style={pdfStyles.notaryWitnessRow}>
              <Text style={pdfStyles.notaryWitnessText}>Witness my hand and official seal this</Text>
              <Text style={[pdfStyles.notaryWitnessLine, { width: 28 }]}> </Text>
              <Text style={pdfStyles.notaryWitnessText}> day of </Text>
              <Text style={[pdfStyles.notaryWitnessLine, { width: 60 }]}> </Text>
              <Text style={pdfStyles.notaryWitnessText}>, 20</Text>
              <Text style={[pdfStyles.notaryWitnessLine, { width: 28 }]}> </Text>
              <Text style={pdfStyles.notaryWitnessText}>.</Text>
            </View>

            {/* Notary Public Signature */}
            <View style={pdfStyles.notarySigRow}>
              <Text style={pdfStyles.notarySigLabel}>Notary Public Signature:</Text>
              <Text style={pdfStyles.notarySigLine}> </Text>
            </View>

            {/* Printed Name */}
            <View style={pdfStyles.notarySigRow}>
              <Text style={pdfStyles.notarySigLabel}>Printed Name:</Text>
              <Text style={pdfStyles.notarySigLine}> </Text>
            </View>

            {/* My Commission Expires */}
            <View style={pdfStyles.notarySigRow}>
              <Text style={pdfStyles.notarySigLabel}>My Commission Expires:</Text>
              <Text style={pdfStyles.notarySigLine}> </Text>
            </View>

            {/* (Seal) — inline on its own row, left-aligned */}
            <View style={pdfStyles.notarySealRow}>
              <Text style={pdfStyles.notarySealLabel}>(Seal)</Text>
              <Text style={pdfStyles.notarySealLine}> </Text>
            </View>

          </View>
        </View>

        {/* Office Use Only */}
        <View style={[pdfStyles.section, { marginTop: 50 }]}>
          <Text style={pdfStyles.sectionTitle}>OFFICE USE ONLY</Text>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Membership Number:</Text><Text style={pdfStyles.fieldValue}> </Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Date Received:</Text><Text style={pdfStyles.fieldValue}> </Text></View>
            <View style={pdfStyles.fieldThird}><Text style={pdfStyles.fieldLabel}>Date Approved:</Text><Text style={pdfStyles.fieldValue}> </Text></View>
          </View>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldHalf}><Text style={pdfStyles.fieldLabel}>Approved By:</Text><Text style={pdfStyles.fieldValue}> </Text></View>
            <View style={pdfStyles.fieldHalf}><Text style={pdfStyles.fieldLabel}>Membership Fee Paid:</Text><Text style={pdfStyles.fieldValue}> </Text></View>
          </View>
          <View style={pdfStyles.row}>
            <View style={pdfStyles.fieldHalf}><Text style={pdfStyles.fieldLabel}>Comments:</Text><Text style={pdfStyles.fieldValue}> </Text></View>
            <View style={pdfStyles.fieldHalf}><Text style={pdfStyles.fieldLabel}>Status:</Text><Text style={pdfStyles.fieldValue}> </Text></View>
          </View>
        </View>

      </Page>
    </Document>
  );

  // ── State ──────────────────────────────────────────────────────────────────
  const [currentStep, setCurrentStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState(new Set());
  const [showBeneficiaryPrompt, setShowBeneficiaryPrompt] = useState(false);
  const [showSpousePrompt, setShowSpousePrompt] = useState(false);
  const [showChildrenPrompt, setShowChildrenPrompt] = useState(false);
  const [showBeneficiarySection, setShowBeneficiarySection] = useState(false);
  const [showSpouseSection, setShowSpouseSection] = useState(false);
  const [showChildrenSection, setShowChildrenSection] = useState(false);
  const [showSecondBeneficiary, setShowSecondBeneficiary] = useState(false);
  const [showBeneficiaryCountError, setShowBeneficiaryCountError] = useState(false);
  const [childCount, setChildCount] = useState(1);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [maritalStatus, setMaritalStatus] = useState('');

  const [formData, setFormData] = useState({
    first_name: '', middle_name: '', last_name: '', dob: '', email: '', phone: '',
    address: '', apt: '', city: '', state: '', zip: '', marital_status: '',
    beneficiary_first_name: '', beneficiary_middle_name: '', beneficiary_last_name: '',
    beneficiary_phone: '', beneficiary_address: '', beneficiary_apt: '',
    beneficiary_city: '', beneficiary_state: '', beneficiary_zip: '',
    beneficiary2_first_name: '', beneficiary2_middle_name: '', beneficiary2_last_name: '',
    beneficiary2_phone: '', beneficiary2_address: '', beneficiary2_apt: '',
    beneficiary2_city: '', beneficiary2_state: '', beneficiary2_zip: '',
    spouse_first_name: '', spouse_middle_name: '', spouse_last_name: '',
    spouse_dob: '', spouse_email: '', spouse_phone: '',
    children: [{ first_name: '', middle_name: '', last_name: '', relationship: '', gender: '', disabled: '', dob: '' }]
  });

  const [errors, setErrors] = useState({});

  const steps = [
    'Applicant Information', 'Beneficiary Information',
    'Spouse Information', 'Children Information', 'Review & Submit'
  ];

  // ── Handlers ───────────────────────────────────────────────────────────────
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'marital_status') setMaritalStatus(value);
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleChildChange = (index, field, value) => {
    const updated = [...formData.children];
    updated[index] = { ...updated[index], [field]: value };
    setFormData(prev => ({ ...prev, children: updated }));
  };

  const addChild = () => {
    if (childCount < 7) {
      setFormData(prev => ({
        ...prev,
        children: [...prev.children, { first_name: '', middle_name: '', last_name: '', relationship: '', gender: '', disabled: '', dob: '' }]
      }));
      setChildCount(prev => prev + 1);
    }
  };

  const removeChild = (index) => {
    if (childCount > 1) {
      setFormData(prev => ({ ...prev, children: prev.children.filter((_, i) => i !== index) }));
      setChildCount(prev => prev - 1);
    }
  };

  const handleDownloadPDF = async () => {
    if (isGeneratingPDF) return;
    setIsGeneratingPDF(true);
    try {
      const blob = await pdf(<MembershipPDF formData={formData} />).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Membership_Application_${new Date().toISOString().split('T')[0]}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      setIsGeneratingPDF(false);
      toast.success('PDF downloaded successfully!');
    } catch (error) {
      console.error('PDF generation error:', error);
      setIsGeneratingPDF(false);
      toast.error('Failed to generate PDF. Please try again.');
    }
  };

  // ── Validation ─────────────────────────────────────────────────────────────
  const validateApplicantSection = () => {
    const newErrors = {};
    ['first_name','last_name','dob','email','phone','address','city','state','zip','marital_status'].forEach(f => {
      if (!formData[f]?.trim()) newErrors[f] = 'This field is required';
    });
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = 'Please enter a valid email address';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateBeneficiarySection = () => {
    const newErrors = {};
    ['beneficiary_first_name','beneficiary_last_name','beneficiary_address','beneficiary_city','beneficiary_state','beneficiary_zip']
      .forEach(f => { if (!formData[f]?.trim()) newErrors[f] = 'This field is required'; });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateSpouseSection = () => {
    if (!showSpouseSection) return true;
    const newErrors = {};
    ['spouse_first_name','spouse_last_name','spouse_dob'].forEach(f => { if (!formData[f]?.trim()) newErrors[f] = 'This field is required'; });
    if (formData.spouse_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.spouse_email)) newErrors.spouse_email = 'Please enter a valid email address';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateChildrenSection = () => {
    if (!showChildrenSection) return true;
    const newErrors = {};
    formData.children.forEach((child, i) => {
      if (child.first_name || child.middle_name || child.last_name || child.relationship || child.gender || child.disabled || child.dob) {
        if (!child.first_name) newErrors[`child${i}_first_name`] = `Please enter a first name for child ${i + 1}`;
        if (!child.last_name) newErrors[`child${i}_last_name`] = `Please enter a last name for child ${i + 1}`;
        if (!child.relationship) newErrors[`child${i}_relationship`] = `Please select a relationship for child ${i + 1}`;
        if (!child.gender) newErrors[`child${i}_gender`] = `Please select a gender for child ${i + 1}`;
        if (!child.disabled) newErrors[`child${i}_disabled`] = `Please select disabled status for child ${i + 1}`;
        if (!child.dob) newErrors[`child${i}_dob`] = `Please enter a birthdate for child ${i + 1}`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ── Step navigation ────────────────────────────────────────────────────────
  const handleApplicantSubmit = () => {
    if (validateApplicantSection()) { setCompletedSteps(prev => new Set([...prev, 0])); setShowBeneficiaryPrompt(true); }
    else toast.error('Please fill in all required fields correctly');
  };

  const handleBeneficiaryPromptResponse = (add) => {
    if (add) { setShowBeneficiaryPrompt(false); setShowBeneficiarySection(true); setCurrentStep(1); }
    else toast.error('A beneficiary is required to proceed.');
  };

  const handleBeneficiarySubmit = () => {
    if (validateBeneficiarySection()) {
      if (!showSecondBeneficiary && !showBeneficiaryCountError) {
        setShowBeneficiaryCountError(true);
        return;
      }
      setCompletedSteps(prev => new Set([...prev, 1]));
      setShowBeneficiarySection(false);
      setShowBeneficiaryCountError(false);
      formData.marital_status === 'Single' ? setShowChildrenPrompt(true) : setShowSpousePrompt(true);
    } else toast.error('Please fill in all required beneficiary fields');
  };

  const handleSpousePromptResponse = (add) => {
    setShowSpousePrompt(false);
    if (add) { setShowSpouseSection(true); setCurrentStep(2); } else setShowChildrenPrompt(true);
  };

  const handleSpouseSubmit = () => {
    if (validateSpouseSection()) { setCompletedSteps(prev => new Set([...prev, 2])); setShowSpouseSection(false); setShowChildrenPrompt(true); }
    else toast.error('Please fill in all required spouse fields');
  };

  const handleChildrenPromptResponse = (add) => {
    setShowChildrenPrompt(false);
    if (add) { setShowChildrenSection(true); setCurrentStep(3); } else setCurrentStep(4);
  };

  const handleChildrenSubmit = () => {
    if (validateChildrenSection()) { setCompletedSteps(prev => new Set([...prev, 3])); setShowChildrenSection(false); setCurrentStep(4); }
    else toast.error('Please complete all children information');
  };

const validateFinalSubmission = () => {
  if (!formData.beneficiary_first_name || !formData.beneficiary_last_name) {
    toast.error('You must add at least 1 beneficiary to complete your application.');
    return false;
  }
  return true;
};
  const handleEditSection = (s) => {
    switch (s) {
      case 0: setCurrentStep(0); break;
      case 1: setShowBeneficiarySection(true); setCurrentStep(1); break;
      case 2: setShowSpouseSection(true); setCurrentStep(2); break;
      case 3: setShowChildrenSection(true); setCurrentStep(3); break;
      default: break;
    }
  };

  const handleBackFromBeneficiary = () => { setShowBeneficiarySection(false); setCurrentStep(0); };
  const handleBackFromSpouse = () => { setShowSpouseSection(false); setShowBeneficiarySection(true); setCurrentStep(1); };
  const handleBackFromChildren = () => {
    setShowChildrenSection(false);
    if (formData.spouse_first_name || formData.spouse_last_name || formData.marital_status !== 'Single') { setShowSpouseSection(true); setCurrentStep(2); }
    else { setShowBeneficiarySection(true); setCurrentStep(1); }
  };
  const handleBackFromSummary = () => {
    if (formData.children.some(c => c.first_name || c.last_name)) { setShowChildrenSection(true); setCurrentStep(3); }
    else if (formData.spouse_first_name || formData.spouse_last_name) { setShowSpouseSection(true); setCurrentStep(2); }
    else { setShowBeneficiarySection(true); setCurrentStep(1); }
  };

  const handleFinalSubmit = async () => {
    if (!validateFinalSubmission()) return;
    try {
      const validChildren = formData.children.filter(c => c.first_name || c.middle_name || c.last_name || c.relationship || c.gender || c.disabled || c.dob);
      const submissionData = {
        applicant: { first_name: formData.first_name, middle_name: formData.middle_name, last_name: formData.last_name, dob: formData.dob, email: formData.email, phone: formData.phone, address: formData.address, apt: formData.apt, city: formData.city, state: formData.state, zip: formData.zip, marital_status: formData.marital_status },
        beneficiary: { first_name: formData.beneficiary_first_name, middle_name: formData.beneficiary_middle_name, last_name: formData.beneficiary_last_name, phone: formData.beneficiary_phone, address: formData.beneficiary_address, apt: formData.beneficiary_apt, city: formData.beneficiary_city, state: formData.beneficiary_state, zip: formData.beneficiary_zip },
        beneficiary2: { first_name: formData.beneficiary2_first_name, middle_name: formData.beneficiary2_middle_name, last_name: formData.beneficiary2_last_name, phone: formData.beneficiary2_phone, address: formData.beneficiary2_address, apt: formData.beneficiary2_apt, city: formData.beneficiary2_city, state: formData.beneficiary2_state, zip: formData.beneficiary2_zip },
        spouse: (formData.spouse_first_name || formData.spouse_last_name) ? { first_name: formData.spouse_first_name, middle_name: formData.spouse_middle_name, last_name: formData.spouse_last_name, dob: formData.spouse_dob, email: formData.spouse_email, phone: formData.spouse_phone } : null,
        children: validChildren,
        signature: { date: new Date().toISOString() },
        createdAt: new Date().toISOString()
      };
      const response = await becomeMemberServices.submitApplication(submissionData);
      if (response.data.success) {
        toast.success('Application submitted successfully!');
        setFormData({ first_name: '', middle_name: '', last_name: '', dob: '', email: '', phone: '', address: '', apt: '', city: '', state: '', zip: '', marital_status: '', beneficiary_first_name: '', beneficiary_middle_name: '', beneficiary_last_name: '', beneficiary_phone: '', beneficiary_address: '', beneficiary_apt: '', beneficiary_city: '', beneficiary_state: '', beneficiary_zip: '', beneficiary2_first_name: '', beneficiary2_middle_name: '', beneficiary2_last_name: '', beneficiary2_phone: '', beneficiary2_address: '', beneficiary2_apt: '', beneficiary2_city: '', beneficiary2_state: '', beneficiary2_zip: '', spouse_first_name: '', spouse_middle_name: '', spouse_last_name: '', spouse_dob: '', spouse_email: '', spouse_phone: '', children: [{ first_name: '', middle_name: '', last_name: '', relationship: '', gender: '', disabled: '', dob: '' }] });
        setCurrentStep(0); setCompletedSteps(new Set());
        setShowBeneficiaryPrompt(false); setShowSpousePrompt(false); setShowChildrenPrompt(false);
        setShowBeneficiarySection(false); setShowSpouseSection(false); setShowChildrenSection(false);
        setShowSecondBeneficiary(false); setShowBeneficiaryCountError(false);
        setChildCount(1); setMaritalStatus(''); setErrors({});
      } else throw new Error(response.data.message || 'Failed to submit application');
    } catch (error) {
      console.error('Error submitting application:', error);
      toast.error(error.message || 'Failed to submit application. Please try again.');
    }
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <Box className="membership-form-container" sx={{ maxWidth: 1200, mx: 'auto', p: { xs: 2, md: 3 } }}>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <Button variant="contained" onClick={handleDownloadPDF} disabled={isGeneratingPDF}
          sx={{ backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, '&:disabled': { backgroundColor: '#6c757d' }, fontWeight: 'bold', fontSize: '16px', padding: '10px 20px', borderRadius: '8px' }}>
          {isGeneratingPDF ? '⏳ Generating PDF...' : '📄 Download PDF'}
        </Button>
      </Box>

      <Box className="form-header-with-logos" sx={{ mb: 4 }}>
        <img src={Logo} alt="Hamsa Lomi Logo" className="header-logo left-logo" />
        <Box className="header-center">
          <Typography variant="h6" className="amharic-text" sx={{ fontSize: { xs: '0.9rem', md: '1.25rem' } }}>
            ሃምሳ ሎሚ የኢትዮጵያውያን ማህበር - ናሽቪል - ቴነሲ
          </Typography>
          <Typography variant="h4" className="membership-form-title" sx={{ fontSize: { xs: '1.5rem', md: '2.125rem' } }}>
            HAMSA LOMI ETHIOPIAN ASSOCIATION MEMBERSHIP APPLICATION
          </Typography>
        </Box>
        <img src={Logo} alt="Hamsa Lomi Logo" className="header-logo right-logo" />
      </Box>

      <Box sx={{ width: '100%', mb: 4 }}>
        <Stepper activeStep={currentStep} alternativeLabel={!isMobile} orientation={isMobile ? 'vertical' : 'horizontal'}
          sx={{ '& .MuiStepLabel-root .Mui-completed': { color: '#4caf50' }, '& .MuiStepLabel-root .Mui-active': { color: '#2196f3' }, '& .MuiStepLabel-label': { fontSize: { xs: '0.75rem', sm: '0.875rem' } } }}>
          {steps.map((label, index) => (
            <Step key={label} completed={completedSteps.has(index)}><StepLabel>{label}</StepLabel></Step>
          ))}
        </Stepper>
      </Box>

      {/* Step 1: Applicant */}
      {currentStep === 0 && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>APPLICANT INFORMATION</Typography>
            <table className="form-table"><tbody>
              <tr>
                <td width="33%">First Name: <input type="text" name="first_name" value={formData.first_name} onChange={handleInputChange} required />{errors.first_name && <div className="error">{errors.first_name}</div>}</td>
                <td width="33%">Middle Name: <input type="text" name="middle_name" value={formData.middle_name} onChange={handleInputChange} /></td>
                <td width="33%">Last Name: <input type="text" name="last_name" value={formData.last_name} onChange={handleInputChange} required />{errors.last_name && <div className="error">{errors.last_name}</div>}</td>
              </tr>
              <tr>
                <td>Date of birth: <input type="date" name="dob" value={formData.dob} onChange={handleInputChange} required />{errors.dob && <div className="error">{errors.dob}</div>}</td>
                <td>E-Mail: <input type="email" name="email" value={formData.email} onChange={handleInputChange} required />{errors.email && <div className="error">{errors.email}</div>}</td>
                <td>Phone: <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required />{errors.phone && <div className="error">{errors.phone}</div>}</td>
              </tr>
              <tr>
                <td colSpan="2">Current address: <input type="text" name="address" value={formData.address} onChange={handleInputChange} required />{errors.address && <div className="error">{errors.address}</div>}</td>
                <td>Apt. #: <input type="text" name="apt" value={formData.apt} onChange={handleInputChange} /></td>
              </tr>
              <tr>
                <td>City: <input type="text" name="city" value={formData.city} onChange={handleInputChange} required />{errors.city && <div className="error">{errors.city}</div>}</td>
                <td>State: <input type="text" name="state" value={formData.state} onChange={handleInputChange} required />{errors.state && <div className="error">{errors.state}</div>}</td>
                <td>Zip: <input type="text" name="zip" value={formData.zip} onChange={handleInputChange} required />{errors.zip && <div className="error">{errors.zip}</div>}</td>
              </tr>
              <tr>
                <td>Marital Status:
                  <select name="marital_status" value={formData.marital_status} onChange={handleInputChange} required>
                    <option value="">Select...</option>
                    <option value="Single">Single</option><option value="Married">Married</option>
                    <option value="Divorced">Divorced</option><option value="Widowed">Widowed</option>
                  </select>
                  {errors.marital_status && <div className="error">{errors.marital_status}</div>}
                </td>
              </tr>
            </tbody></table>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant="contained" onClick={handleApplicantSubmit} sx={{ minWidth: 120, backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>Continue</Button>
            </Box>
          </CardContent>
        </Card>
      )}

      <Dialog open={showBeneficiaryPrompt} onClose={() => {}} maxWidth="sm" fullWidth>
        <DialogTitle>Add Beneficiary</DialogTitle>
        <DialogContent><Typography>Would you like to add a Beneficiary? A beneficiary is required to proceed with your application.</Typography></DialogContent>
        <DialogActions>
          <Button onClick={() => handleBeneficiaryPromptResponse(false)} color="secondary">No</Button>
          <Button onClick={() => handleBeneficiaryPromptResponse(true)} variant="contained" sx={{ backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>Yes, Add Beneficiary</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showBeneficiaryCountError} onClose={() => setShowBeneficiaryCountError(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add Second Beneficiary?</DialogTitle>
        <DialogContent><Typography>Would you like to add a second beneficiary?</Typography></DialogContent>
        <DialogActions>
          <Button onClick={() => { setShowBeneficiaryCountError(false); setShowSecondBeneficiary(false); formData.marital_status === 'Single' ? setShowChildrenPrompt(true) : setShowSpousePrompt(true); }} color="secondary">No</Button>
          <Button onClick={() => { setShowBeneficiaryCountError(false); setShowSecondBeneficiary(true); }} variant="contained"
            sx={{ backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>Yes</Button>
        </DialogActions>
      </Dialog>

      {/* Step 2: Beneficiary */}
      {showBeneficiarySection && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>BENEFICIARY INFORMATION</Typography>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>Beneficiary 1</Typography>
            <table className="form-table"><tbody>
              <tr>
                <td width="33%">First Name: <input type="text" name="beneficiary_first_name" value={formData.beneficiary_first_name} onChange={handleInputChange} required />{errors.beneficiary_first_name && <div className="error">{errors.beneficiary_first_name}</div>}</td>
                <td width="33%">Middle Name: <input type="text" name="beneficiary_middle_name" value={formData.beneficiary_middle_name} onChange={handleInputChange} /></td>
                <td width="33%">Last Name: <input type="text" name="beneficiary_last_name" value={formData.beneficiary_last_name} onChange={handleInputChange} required />{errors.beneficiary_last_name && <div className="error">{errors.beneficiary_last_name}</div>}</td>
              </tr>
              <tr><td colSpan="3">Phone: <input type="tel" name="beneficiary_phone" value={formData.beneficiary_phone} onChange={handleInputChange} /></td></tr>
              <tr>
                <td colSpan="2">Address: <input type="text" name="beneficiary_address" value={formData.beneficiary_address} onChange={handleInputChange} required />{errors.beneficiary_address && <div className="error">{errors.beneficiary_address}</div>}</td>
                <td>Apt. #: <input type="text" name="beneficiary_apt" value={formData.beneficiary_apt} onChange={handleInputChange} /></td>
              </tr>
              <tr>
                <td>City: <input type="text" name="beneficiary_city" value={formData.beneficiary_city} onChange={handleInputChange} required />{errors.beneficiary_city && <div className="error">{errors.beneficiary_city}</div>}</td>
                <td>State: <input type="text" name="beneficiary_state" value={formData.beneficiary_state} onChange={handleInputChange} required />{errors.beneficiary_state && <div className="error">{errors.beneficiary_state}</div>}</td>
                <td>Zip: <input type="text" name="beneficiary_zip" value={formData.beneficiary_zip} onChange={handleInputChange} required />{errors.beneficiary_zip && <div className="error">{errors.beneficiary_zip}</div>}</td>
              </tr>
            </tbody></table>

            {showSecondBeneficiary && (
              <React.Fragment>
                <Box sx={{ mt: 4, mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Beneficiary 2</Typography><Button color="error" variant="outlined" size="small" onClick={() => { setShowSecondBeneficiary(false); setFormData(prev => ({ ...prev, beneficiary2_first_name: '', beneficiary2_middle_name: '', beneficiary2_last_name: '', beneficiary2_phone: '', beneficiary2_address: '', beneficiary2_apt: '', beneficiary2_city: '', beneficiary2_state: '', beneficiary2_zip: '' })); }}>Remove</Button></Box>
                <table className="form-table"><tbody>
                  <tr>
                    <td width="33%">First Name: <input type="text" name="beneficiary2_first_name" value={formData.beneficiary2_first_name} onChange={handleInputChange} required />{errors.beneficiary2_first_name && <div className="error">{errors.beneficiary2_first_name}</div>}</td>
                    <td width="33%">Middle Name: <input type="text" name="beneficiary2_middle_name" value={formData.beneficiary2_middle_name} onChange={handleInputChange} /></td>
                    <td width="33%">Last Name: <input type="text" name="beneficiary2_last_name" value={formData.beneficiary2_last_name} onChange={handleInputChange} required />{errors.beneficiary2_last_name && <div className="error">{errors.beneficiary2_last_name}</div>}</td>
                  </tr>
                  <tr><td colSpan="3">Phone: <input type="tel" name="beneficiary2_phone" value={formData.beneficiary2_phone} onChange={handleInputChange} /></td></tr>
                  <tr>
                    <td colSpan="2">Address: <input type="text" name="beneficiary2_address" value={formData.beneficiary2_address} onChange={handleInputChange} required />{errors.beneficiary2_address && <div className="error">{errors.beneficiary2_address}</div>}</td>
                    <td>Apt. #: <input type="text" name="beneficiary2_apt" value={formData.beneficiary2_apt} onChange={handleInputChange} /></td>
                  </tr>
                  <tr>
                    <td>City: <input type="text" name="beneficiary2_city" value={formData.beneficiary2_city} onChange={handleInputChange} required />{errors.beneficiary2_city && <div className="error">{errors.beneficiary2_city}</div>}</td>
                    <td>State: <input type="text" name="beneficiary2_state" value={formData.beneficiary2_state} onChange={handleInputChange} required />{errors.beneficiary2_state && <div className="error">{errors.beneficiary2_state}</div>}</td>
                    <td>Zip: <input type="text" name="beneficiary2_zip" value={formData.beneficiary2_zip} onChange={handleInputChange} required />{errors.beneficiary2_zip && <div className="error">{errors.beneficiary2_zip}</div>}</td>
                  </tr>
                </tbody></table>
              </React.Fragment>
            )}

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', rowGap: 2 }}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button variant="contained" onClick={handleBackFromBeneficiary} sx={{ minWidth: 120, backgroundColor: '#6c757d', color: '#fff', '&:hover': { backgroundColor: '#5a6268' } }}>Back</Button>
                {!showSecondBeneficiary && (
                  <Button variant="outlined" onClick={() => setShowSecondBeneficiary(true)} sx={{ minWidth: 160, borderColor: '#28a745', color: '#28a745', '&:hover': { borderColor: '#218838', color: '#218838' }, fontWeight: 'bold' }}>Add Second Beneficiary</Button>
                )}
              </Box>
              <Button variant="contained" onClick={handleBeneficiarySubmit} sx={{ minWidth: 120, backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>Continue</Button>
            </Box>
          </CardContent>
        </Card>
      )}

      <Dialog open={showSpousePrompt} onClose={() => {}} maxWidth="sm" fullWidth>
        <DialogTitle>Add Spouse</DialogTitle>
        <DialogContent><Typography>Would you like to add Spouse information to your application?</Typography></DialogContent>
        <DialogActions>
          <Button onClick={() => handleSpousePromptResponse(false)} color="secondary">No, Skip</Button>
          <Button onClick={() => handleSpousePromptResponse(true)} variant="contained" sx={{ backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>Yes, Add Spouse</Button>
        </DialogActions>
      </Dialog>

      {/* Step 3: Spouse */}
      {showSpouseSection && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>SPOUSE INFORMATION</Typography>
            <table className="form-table"><tbody>
              <tr>
                <td width="33%">First Name: <input type="text" name="spouse_first_name" value={formData.spouse_first_name} onChange={handleInputChange} required />{errors.spouse_first_name && <div className="error">{errors.spouse_first_name}</div>}</td>
                <td width="33%">Middle Name: <input type="text" name="spouse_middle_name" value={formData.spouse_middle_name} onChange={handleInputChange} /></td>
                <td width="33%">Last Name: <input type="text" name="spouse_last_name" value={formData.spouse_last_name} onChange={handleInputChange} required />{errors.spouse_last_name && <div className="error">{errors.spouse_last_name}</div>}</td>
              </tr>
              <tr>
                <td>Date of birth: <input type="date" name="spouse_dob" value={formData.spouse_dob} onChange={handleInputChange} required />{errors.spouse_dob && <div className="error">{errors.spouse_dob}</div>}</td>
                <td>E-Mail: <input type="email" name="spouse_email" value={formData.spouse_email} onChange={handleInputChange} />{errors.spouse_email && <div className="error">{errors.spouse_email}</div>}</td>
                <td>Phone: <input type="tel" name="spouse_phone" value={formData.spouse_phone} onChange={handleInputChange} /></td>
              </tr>
            </tbody></table>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
              <Button variant="contained" onClick={handleBackFromSpouse} sx={{ minWidth: 120, backgroundColor: '#6c757d', color: '#fff', '&:hover': { backgroundColor: '#5a6268' } }}>Back</Button>
              <Button variant="contained" onClick={handleSpouseSubmit} sx={{ minWidth: 120, backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>Continue</Button>
            </Box>
          </CardContent>
        </Card>
      )}

      <Dialog open={showChildrenPrompt} onClose={() => {}} maxWidth="sm" fullWidth>
        <DialogTitle>Add Children</DialogTitle>
        <DialogContent><Typography>Would you like to add Children information to your application?</Typography></DialogContent>
        <DialogActions>
          <Button onClick={() => handleChildrenPromptResponse(false)} color="secondary">No, Skip</Button>
          <Button onClick={() => handleChildrenPromptResponse(true)} variant="contained" sx={{ backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>Yes, Add Children</Button>
        </DialogActions>
      </Dialog>

      {/* Step 4: Children */}
      {showChildrenSection && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>CHILDREN INFORMATION</Typography>
            {formData.children.map((child, index) => (
              <Box key={index} sx={{ mb: 3, p: 2, border: '1px solid #ddd', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 2, fontSize: { xs: '1rem', md: '1.25rem' } }}>
                  Child {index + 1}
                  {childCount > 1 && <Button onClick={() => removeChild(index)} color="error" size="small" sx={{ ml: 2 }}>Remove</Button>}
                </Typography>
                <table className="form-table"><tbody>
                  <tr>
                    <td width="33%">First Name: <input type="text" value={child.first_name} onChange={(e) => handleChildChange(index, 'first_name', e.target.value)} />{errors[`child${index}_first_name`] && <div className="error">{errors[`child${index}_first_name`]}</div>}</td>
                    <td width="33%">Middle Name: <input type="text" value={child.middle_name} onChange={(e) => handleChildChange(index, 'middle_name', e.target.value)} /></td>
                    <td width="34%">Last Name: <input type="text" value={child.last_name} onChange={(e) => handleChildChange(index, 'last_name', e.target.value)} />{errors[`child${index}_last_name`] && <div className="error">{errors[`child${index}_last_name`]}</div>}</td>
                  </tr>
                  <tr>
                    <td colSpan="3">Relationship:
                      <select value={child.relationship} onChange={(e) => handleChildChange(index, 'relationship', e.target.value)}>
                        <option value="">Select...</option><option value="Son">Son</option>
                        <option value="Daughter">Daughter</option><option value="Stepson">Stepson</option>
                        <option value="Stepdaughter">Stepdaughter</option>
                      </select>
                      {errors[`child${index}_relationship`] && <div className="error">{errors[`child${index}_relationship`]}</div>}
                    </td>
                  </tr>
                  <tr>
                    <td>Gender:
                      <select value={child.gender} onChange={(e) => handleChildChange(index, 'gender', e.target.value)}>
                        <option value="">Select...</option><option value="Male">Male</option><option value="Female">Female</option>
                      </select>
                      {errors[`child${index}_gender`] && <div className="error">{errors[`child${index}_gender`]}</div>}
                    </td>
                    <td>Date of birth: <input type="date" value={child.dob} onChange={(e) => handleChildChange(index, 'dob', e.target.value)} />{errors[`child${index}_dob`] && <div className="error">{errors[`child${index}_dob`]}</div>}</td>
                  </tr>
                  <tr>
                    <td>Disabled:
                      <select value={child.disabled} onChange={(e) => handleChildChange(index, 'disabled', e.target.value)}>
                        <option value="">Select...</option><option value="Yes">Yes</option><option value="No">No</option>
                      </select>
                      {errors[`child${index}_disabled`] && <div className="error">{errors[`child${index}_disabled`]}</div>}
                    </td>
                  </tr>
                </tbody></table>
              </Box>
            ))}
            {childCount < 7 && (
              <Button variant="outlined" onClick={addChild} sx={{ mb: 3, borderColor: '#28a745', color: '#28a745', '&:hover': { borderColor: '#218838', backgroundColor: 'rgba(40,167,69,0.04)' } }}>Add Another Child</Button>
            )}
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
              <Button variant="contained" onClick={handleBackFromChildren} sx={{ minWidth: 120, backgroundColor: '#6c757d', color: '#fff', '&:hover': { backgroundColor: '#5a6268' } }}>Back</Button>
              <Button variant="contained" onClick={handleChildrenSubmit} sx={{ minWidth: 120, backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold' }}>Continue</Button>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* Step 5: Review & Submit */}
      {currentStep === 4 && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h5" className="section-title" sx={{ mb: 3, fontSize: { xs: '1.25rem', md: '1.5rem' } }}>REVIEW & SUBMIT APPLICATION</Typography>
            <Typography variant="h6" sx={{ mb: 2 }}>Application Summary:</Typography>

            <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Applicant Information</Typography>
                <Button size="small" variant="outlined" onClick={() => handleEditSection(0)} sx={{ borderColor: '#2196f3', color: '#2196f3', '&:hover': { borderColor: '#1976d2', backgroundColor: 'rgba(33,150,243,0.04)' } }}>Edit</Button>
              </Box>
              <Typography>{formData.first_name} {formData.middle_name} {formData.last_name}</Typography>
              <Typography>DOB: {formData.dob}</Typography>
              <Typography>{formData.email} | {formData.phone}</Typography>
              <Typography>{formData.address}{formData.apt ? `, Apt ${formData.apt}` : ''}, {formData.city}, {formData.state} {formData.zip}</Typography>
              <Typography>Marital Status: {formData.marital_status}</Typography>
            </Box>

            <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Beneficiary Information</Typography>
                <Button size="small" variant="outlined" onClick={() => handleEditSection(1)} sx={{ borderColor: '#2196f3', color: '#2196f3', '&:hover': { borderColor: '#1976d2', backgroundColor: 'rgba(33,150,243,0.04)' } }}>Edit</Button>
              </Box>
              <Typography sx={{ fontWeight: 'bold', mb: 0.5 }}>Beneficiary 1</Typography>
              <Typography>{formData.beneficiary_first_name} {formData.beneficiary_middle_name} {formData.beneficiary_last_name}</Typography>
              <Typography>Phone: {formData.beneficiary_phone}</Typography>
              <Typography sx={{ mb: 2 }}>{formData.beneficiary_address}{formData.beneficiary_apt ? `, Apt ${formData.beneficiary_apt}` : ''}, {formData.beneficiary_city}, {formData.beneficiary_state} {formData.beneficiary_zip}</Typography>
              <Typography sx={{ fontWeight: 'bold', mb: 0.5 }}>Beneficiary 2</Typography>
              <Typography>{formData.beneficiary2_first_name} {formData.beneficiary2_middle_name} {formData.beneficiary2_last_name}</Typography>
              <Typography>Phone: {formData.beneficiary2_phone}</Typography>
              <Typography>{formData.beneficiary2_address}{formData.beneficiary2_apt ? `, Apt ${formData.beneficiary2_apt}` : ''}, {formData.beneficiary2_city}, {formData.beneficiary2_state} {formData.beneficiary2_zip}</Typography>
            </Box>

            {(formData.spouse_first_name || formData.spouse_last_name) && (
              <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Spouse Information</Typography>
                  <Button size="small" variant="outlined" onClick={() => handleEditSection(2)} sx={{ borderColor: '#2196f3', color: '#2196f3', '&:hover': { borderColor: '#1976d2', backgroundColor: 'rgba(33,150,243,0.04)' } }}>Edit</Button>
                </Box>
                <Typography>{formData.spouse_first_name} {formData.spouse_middle_name} {formData.spouse_last_name}</Typography>
                <Typography>DOB: {formData.spouse_dob}</Typography>
                <Typography>{formData.spouse_email} | {formData.spouse_phone}</Typography>
              </Box>
            )}

            {formData.children.some(c => c.first_name || c.last_name) && (
              <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Children Information</Typography>
                  <Button size="small" variant="outlined" onClick={() => handleEditSection(3)} sx={{ borderColor: '#2196f3', color: '#2196f3', '&:hover': { borderColor: '#1976d2', backgroundColor: 'rgba(33,150,243,0.04)' } }}>Edit</Button>
                </Box>
                {formData.children.filter(c => c.first_name || c.last_name).map((child, index) => (
                  <Typography key={index}>
                    {`${child.first_name || ''} ${child.middle_name ? child.middle_name + ' ' : ''}${child.last_name || ''}`.trim()} - {child.relationship} ({child.gender}, DOB: {child.dob}, Disabled: {child.disabled})
                  </Typography>
                ))}
              </Box>
            )}

            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Button variant="contained" onClick={handleBackFromSummary} sx={{ minWidth: 120, backgroundColor: '#6c757d', color: '#fff', '&:hover': { backgroundColor: '#5a6268' } }}>Back</Button>
              <Button variant="contained" onClick={handleFinalSubmit} size="large"
                sx={{ minWidth: 200, fontSize: '1.1rem', backgroundColor: '#28a745', '&:hover': { backgroundColor: '#218838' }, fontWeight: 'bold', padding: '12px 24px' }}>
                Submit Application
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default StepByStepMembershipForm;
